import { useState, useEffect } from "react";

import {
  Button,
  Typography,
  ArrowButton,
  ExpandablePanel,
  ExpandablePanelBody,
  ExpandablePanelHeader,
  Tooltip, IconWrapper,
  Modal, Select,
  Table, TableMetadata, useTable, InfoPanel, Autocomplete,
  AutocompleteSearchData, SelectData, TextField, DocumentList, DatePicker,
  DocumentListItem
} from "@king-ict/eupisi-ui/components";
import { ReactComponent as DocumentApprovedIcon } from "@king-ict/eupisi-ui/components/Icon/DocumentApprovedIcon.svg";
import { ReactComponent as EditIcon } from "@king-ict/eupisi-ui/components/Icon/Edit.svg";
import { ReactComponent as InfoIcon } from "@king-ict/eupisi-ui/components/Icon/Info.svg";
import { ReactComponent as UploadIcon } from "@king-ict/eupisi-ui/components/Icon/Upload.svg";
import { useValidation } from "@king-ict/eupisi-ui/hooks";
import { CodeBook, DocumentData, RequestStatusEnum } from "@king-ict/eupisi-ui/models";
import { hrDate, nameof, codeBookToSelectData } from "@king-ict/eupisi-ui/utils";
import { saveAs } from "file-saver";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation, useParams } from "react-router";

import {
  getInstitutionRequest, createSingleProgramRequestGroup,
  getProgramRequestDetail, setProgramRequestStatus,
  downloadProgramRequestPdf, undoProgramRequestChanges, createProgramRequestResolution,
  getProgramRequestTeacher,
  DocumentUploadRequest,
  uploadDocument, getProgramRequestStatusHistoryById, takeOverProcessing, getEnvelopeData, getASOOUsers, getMZOUsers, editEnvelope,
  downloadDocument, saveOtherLocations, submitPausedProgramRequest
} from "../../api/nisooApi";
import { CreateProgramRequestStatus } from "../../api/ProgramRequest/CreateProgramRequestStatus";
import {
  editProgramRequest, saveForeignLanguage,
  saveOtherLegalEntityLocation, createConsent, createHarmonization, getHistoricProgramRequestDetail,
  reassignAdministrator, saveTeachers
} from "../../api/ProgramRequest/programRequestApi";
import { ConsentModal } from "../../components/ConsentModal/ConsentModal";
import { DocumentsUploadModal } from "../../components/DocumentsUploadModal";
import { ConfirmModal, ConfirmModalState } from "../../components/FormControls/ConfirmModal";
import { OtherLegalEntityLocationModal } from "../../components/FormControls/OtherLegalEntityLocationModal";
import { ProgramRequestDetailPanel } from "../../components/FormControls/ProgramRequestDetailPanel";
import { ModalResolution } from "../../components/ModalResolution";
import { ModalStatus } from "../../components/ModalStatus";
import { ProgramRequestHeader } from "../../components/ProgramRequestHeader";
import StaticField from "../../components/StaticField";
import UploadButton from "../../components/UploadButton";
import { useInput } from "../../hooks";
import { DocumentType } from "../../models/Document";
import {
  Institution, InstitutionLocation,
  LocationState,
  institutionInitial
} from "../../models/Institution";
// import {	NewProgramRequest, NewProgramRequestDetail, createProgramRequestDetailInitial vidi ovo
import {
  ProgramRequest, ProgramRequestDetail, createProgramRequestDetailInitial,
  createProgramRequestInitial, convertFromProgramRequest,
  createResolutionDocument, CreateResolutionDocumentRequest, ExecutionResolutionDocument,
  ProgramRequestType, OtherLegalEntityLocation, createOtherLegalEntityLocation,
  ProgramRequestDetailValidationScheme, GetHistoricProgramRequestDetailRequest, ProgramRequestStatusHistory, Competence,
  PreviousPage, TeacherLanguage, ProgramRequestEnvelopeListItem, AssignAdministratorRequest,
  EnvelopeClassificationRequest, OtherLocationRequest
} from "../../models/ProgramRequest";
import { AdditionalDocumentation } from "../../models/ProgramRequest/AdditionalDocumentation";
import { AdditionalDocumentationType } from "../../models/ProgramRequest/AdditionalDocumentationType";
import { Consent, createDefaultConsent } from "../../models/ProgramRequest/Consent";
import { Module } from "../../models/ProgramRequest/Module";
import { ProgramRequestStatus } from "../../models/ProgramRequest/ProgramRequestStatus";
import { ProgramRequestTeacher } from "../../models/ProgramRequest/ProgramRequestTeacher";
import { ResolutionDocumentType } from "../../models/ProgramRequest/ResolutionDocumentType";
import { AppUserRole } from "../../models/User";
import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetUserSessionQuery } from "../../queries/userQuery";
import {
  dashboardRoute,
  programRequestListRoute, programRequestEditUrl,
  programRequestMzoUrl, newProgramRequestListRoute,
} from "../../routes/routes";
import { EnumUtils } from "../../utils";
import InstitutionPanel from "../Institution/InstitutionPanel";
import { OtherLegalEntityInfo } from "../ProgramRequestEdit/OtherLegalEntityInfo";
import TeacherInfo from "../ProgramRequestEdit/TeacherInfo";
import OtherLegalEntityPanel from "./OtherLegalEntityPanel";
import styles from "./ProgramRequestDetails.module.scss";
import ProgramRequestEnvelopePanel from "./ProgramRequestEnvelopePanel";
import { ProgramRequestHistoryPanel } from "./ProgramRequestHistoryPanel";
import ProgramRequestModulePanel from "./ProgramRequestModulePanel";
import ProgramRequestTeacherPanel from "./ProgramRequestTeacherPanel";

export default function ProgramRequestDetails() {

  const createDefaultAssignAdministratorRequest = (): AssignAdministratorRequest => {
    return {
      envelopeId: 0,
      administratorId: undefined,
    };
  };

  const createDefaultEnvelopeClassificationRequest = (): EnvelopeClassificationRequest => {
    return {
      envelopeId: 0,
      classificationMark: "",
      registryNumber: "",
      registrationDate: new Date()
    };
  };

  const createDefaultOtherLocationRequest = (): OtherLocationRequest => {
    return {
      programRequestId: 0,
      programRequestDetailId: 0,
      institutionLocationDetailIds: [] as number[]
    };
  };

  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<{ previousPage: PreviousPage, historyId?: number }>();
  const params = useParams<{ programRequestId: string }>();

  const [openStatusUnlockModal, setOpenStatusUnlockModal] = useState(false);
  const [unloackStatus, setUnloackStatus] = useState<ProgramRequestStatus>(ProgramRequestStatus.UnlockedASOO);
  const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);
  const [openResolutionModal, setOpenResolutionModal] = useState(false);
  const [openStatusSubmitMZOModal, setOpenStatusSubmitMZOModal] = useState(false);
  const [openStatusRevokeModal, setOpenStatusRevokeModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openUnlockConfirmationModal, setOpenUnlockConfirmationModal] = useState(false);
  const [openResolutionConfirmModal, setOpenResolutionConfirmModal] = useState(false);
  const [openPausedRequestConfirmModal, setOpenPausedRequestConfirmModal] = useState(false);
  const [openPausedRequestSuccessModal, setOpenPausedRequestSuccessModal] = useState(false);

  const [resolutionDocument, setResolutionDocument] = useState<ExecutionResolutionDocument>(createResolutionDocument(ResolutionDocumentType.ExpertOpinion, ""));
  const [resolutionModalCaptions, setResolutionModalCaptions] = useState<string[]>([]);
  const [isCorrectionResolution, setIsCorrectionResolution] = useState<boolean>(false);

  const [openLearningSetCodeModal, setOpenLearningSetCodeModal] = useState(false);
  const [openStatusEditApprovedModal, setOpenStatusEditApprovedModal] = useState(false);
  const [showModalComment, setShowModalComment] = useState<boolean>(true);
  const [undoProgramRequestChangeModal, setUndoProgramRequestChangeModal] = useState(false);
  const [ministryAdminMessageUnlock, setMinistryAdminMessageUnlock] = useState("");
  const [ministryAdminMessageReject, setMinistryAdminMessageReject] = useState("");
  const [institutionAdminMessageEdit, setInstitutionAdminMessageEdit] = useState("");
  const [openConsentModal, setOpenConsentModal] = useState<boolean>(false);
  const [consent, setConsent] = useState<ExecutionResolutionDocument | undefined>();

  const [requestStatusId, setRequestStatusId] = useState(0);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [learningSetCodeMessage, setLearningSetCodeMessage] = useState("");

  const [activeRequestId, setActiveRequestId] = useState(parseInt(params.programRequestId));
  const [institution, setInstitution] = useState<Institution>(institutionInitial);
  const [programRequest, setProgramRequest] = useState<ProgramRequest>(createProgramRequestInitial);
  const [programRequestDetail, setProgramRequestDetail] = useState<ProgramRequestDetail>(createProgramRequestDetailInitial);
  const [programRequestCorrection, setProgramRequestCorrection] = useState<ProgramRequestDetail | undefined>(undefined);
  const { data: userSession } = useGetUserSessionQuery();
  const [programRequestType, setProgramRequestType] = useState<ProgramRequestType | undefined>();
  const [isConsentForeignLanguageType, setIsConsentForeignLanguageType] = useState<boolean>(false);
  const [isConsentForHarmonization, setIsConsentForHarmonization] = useState<boolean>(false);
  const [otherLegalEntityLocationModalOpen, setOtherLegalEntityLocationModalOpen] = useState<boolean>(false);
  const [otherLegalEntityLocation, setOtherLegalEntityLocation] = useState<OtherLegalEntityLocation | undefined>();
  const [otherLegalEntityLocationFilteredList, setOtherLegalEntityLocationFilteredList] = useState<OtherLegalEntityLocation[]>([]);
  const [otherLocationModalOpen, setOtherLocationModalOpen] = useState<boolean>(false);
  const [otherLocationConfirmModalOpen, setOtherLocationConfirmModalOpen] = useState<boolean>(false);
  const [otherLocationSuccessModalOpen, setOtherLocationSuccessModalOpen] = useState<boolean>(false);
  const [otherLocationCancelModalOpen, setOtherLocationCancelModalOpen] = useState<boolean>(false);
  const [saveConfirmModalState, setSaveConfirmModalState] = useState<ConfirmModalState>(ConfirmModalState.Closed);
  const [saveConfirmModalConfirmButton, setSaveConfirmModalConfirmButton] = useState<string | undefined>();
  const [saveConfirmModalCancelButton, setSaveConfirmModalCancelButton] = useState<string | undefined>();
  const [saveConfirmModalTitle, setSaveConfirmModalTitle] = useState<string>("");
  const [saveConfirmModalDescription, setSaveConfirmModalDescription] = useState<string>(t("request.areYouSureRequestSave"));
  const [saveConfirmModalMessage, setSaveConfirmModalMessage] = useState<string>(t("request.areYouSureRequestSave"))
  const [saveConfirmModalSuccessMessage, setSaveConfirmModalSuccessMessage] = useState<string>(t("request.requestSuccessfullySubmitted"))
  const [saveConfirmModalLocationState, setSaveConfirmModalLocationState] = useState<ConfirmModalState>(ConfirmModalState.Closed);
  const [resolution, setResolution] = useState<ExecutionResolutionDocument>(resolutionDocument);
  const [envelopeData, setEnvelopeData] = useState<ProgramRequestEnvelopeListItem | undefined>();
  const { handleChange } = useInput();
  const [errors, doValidations] = useValidation({
    data: programRequestDetail,
    validationSchema: ProgramRequestDetailValidationScheme,
  });

  const [requestAdministrator, setRequestAdministrator] = useState(programRequestDetail.envelope?.receivedBy);

  const [tmpResolution, setTmpResolution] = useState<ExecutionResolutionDocument>(resolutionDocument);
  const [tmpApproved, setTmpApproved] = useState<boolean>(false);

  const [isAssignDifferentAdministratorModalOpened, setIsAssignDifferentAdministratorModalOpened] = useState(false);
  const [assignAdministratorRequest, setAssignAdministratorRequest] = useState<AssignAdministratorRequest>(createDefaultAssignAdministratorRequest);
  const [filteredAdministrators, setFilteredAdministrators] = useState<AppUserRole[]>([] as AppUserRole[]);
  const [administratorConfirmationMessage, setAdministratorConfirmationMessage] = useState("");
  const [isConfirmAssignAdministratorModalOpened, setIsConfirmAssignAdministratorModalOpened] = useState(false);
  const [selectedAdminName, setSelectedAdminName] = useState<string>("");
  const [isOfficeEditModalOpened, setIsOfficeEditModalOpened] = useState(false);
  const [envelopeClassificationRequest, setEnvelopeClassificationRequest] = useState<EnvelopeClassificationRequest>(createDefaultEnvelopeClassificationRequest);
  const [isOfficeEditConfirmModalOpened, setIsOfficeEditConfirmModalOpened] = useState(false);
  const [isOfficeEditSuccessModalOpened, setIsOfficeEditSuccessModalOpened] = useState(false);
  const [requestClassificationMark, setRequestClassificationMark] = useState(programRequest.programRequestDetail.envelope?.classificationMark);
  const [requestRegistryNumber, setRequestRegistryNumber] = useState(programRequest.programRequestDetail.envelope?.registryNumber);
  const [requestRegistrationDate, setRequestRegistrationDate] = useState(programRequest.programRequestDetail.envelope?.registrationDate);

  const [otherLocationRequest, setOtherLocationRequest] = useState<OtherLocationRequest>(createDefaultOtherLocationRequest);
  const [otherLocationValidationError, setOtherLocationValidationError] = useState<string>();
  const [filteredLocations, setFilteredLocations] = useState<CodeBook[]>([] as CodeBook[]);
  const [isEnvelopeEditMode, setIsEnvelopeEditMode] = useState(false);
  const [openUploadAdditionalDocumentationModal, setOpenUploadAdditionalDocumentationModal] = useState(false);

  const [subsequentTeacherAddition, setSubsequentTeacherAddition] = useState<boolean>(false);

  const showPdfExport = userSession;

  useEffect(() => {
    const fetchProgramRequest = async () => {

      if (location.state?.historyId) {
        var historyData = await getProgramRequestStatusHistoryById(location.state.historyId);
        const request: GetHistoricProgramRequestDetailRequest = {
          programRequestHistoryId: historyData.id,
          programRequestId: activeRequestId,
          programRequestDetailId: (historyData.requestDetailId === undefined ? 0 : historyData.requestDetailId),
          programRequestStatusId: historyData.requestStatusId,
          programRequestStatus: historyData.requestStatus
        };
        var results = await getHistoricProgramRequestDetail(request);

        setMinistryAdminMessageUnlock("");
        setMinistryAdminMessageReject("");
        setInstitutionAdminMessageEdit("");
      }
      else {
        var results = await getProgramRequestDetail(activeRequestId);
      }

      if (results) {
        setActiveRequestId(results.id);
        setProgramRequest(results);

        if (userSession && (userSession.roleId === RoleEnum.ASOOOffice || userSession.roleId === RoleEnum.CASOffice)) {
          var envelopeClassificationRequestInit = {
            envelopeId: results.programRequestDetail.envelope?.id!,
            classificationMark: results.programRequestDetail.envelope?.classificationMark!,
            registryNumber: results.programRequestDetail.envelope?.registryNumber!,
            registrationDate: results.programRequestDetail.envelope?.registrationDate!
          };

          setEnvelopeClassificationRequest(envelopeClassificationRequestInit);
        }

        if (userSession && (userSession.roleId === RoleEnum.ASOOManager || userSession.roleId === RoleEnum.CASManager)) {
          if ((!location.state || !location.state.historyId) && results.programRequestDetail.envelope) {
            var envelopeData = await getEnvelopeData(results.programRequestDetail.envelope?.id);
            setEnvelopeData(envelopeData);
          }
        }

        if (results && results.institutionId > 0) {
          var institutionResults = await getInstitutionRequest(results.institutionId);

          setInstitution(institutionResults);

          if (results.requestStatusId === ProgramRequestStatus.UnlockedASOO && results.programRequestStatusHistorys.length > 0) {

            let message = results.programRequestStatusHistorys[results.programRequestStatusHistorys.length - 1].description;

            setMinistryAdminMessageUnlock(t("request.unlockNoteLabel", { note: message }));
          }
          else if (results.requestStatusId === ProgramRequestStatus.Rejected && results.programRequestStatusHistorys.length > 0) {

            let message = results.programRequestStatusHistorys[results.programRequestStatusHistorys.length - 1].description;

            setMinistryAdminMessageReject(t("request.rejectNoteLabel", { note: message }));
          }
          else if (results.requestStatusId === ProgramRequestStatus.Opened && results.programRequestStatusHistorys.length > 1 &&
            results.programRequestStatusHistorys[results.programRequestStatusHistorys.length - 2].requestStatusId === ProgramRequestStatus.UnlockedASOO) {

            let message = results.programRequestStatusHistorys[results.programRequestStatusHistorys.length - 1].description;

            if (!message) {
              message = t("request.editNoChangesNoteLabel");
            }

            setInstitutionAdminMessageEdit(message);
          }

        }
        if (results.programRequestDetail) {
          setProgramRequestDetail(results.programRequestDetail);
        }
        if (results && results.requestStatusId !== ProgramRequestStatus.Rejected) {
          setProgramRequestCorrection(results.programRequestDetailCopy);
        }
        else {
          setProgramRequestCorrection(undefined);
        }
      }
    }


    window.scrollTo(0, 0);
    fetchProgramRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, [params.programRequestId, location.state?.historyId, requestStatusId, requestAdministrator, requestClassificationMark, requestRegistryNumber, requestRegistrationDate]);

  useEffect(() => {
    // This list may be updated dynamically and we need to filter
    // what we show.
    if (programRequestDetail.otherLegalEntityLocations) {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      // Dates from the DB appear to be strings and don't compare.
      const arr = programRequestDetail.otherLegalEntityLocations.filter(v => new Date(v.dateTo) >= today);
      setOtherLegalEntityLocationFilteredList(arr);
    } else {
      setOtherLegalEntityLocationFilteredList([]);
    }

  }, [programRequestDetail.otherLegalEntityLocations]);

  useEffect(() => {
    const getAdministrators = async () => {
      if (userSession?.roleId === RoleEnum.ASOOManager) {
        var administrators = await getASOOUsers();
        setFilteredAdministrators(administrators);
      }
      else if (userSession?.roleId === RoleEnum.CASManager) {
        var administrators = await getMZOUsers();
        setFilteredAdministrators(administrators);
      }

    };

    if (userSession?.roleId === RoleEnum.ASOOManager || userSession?.roleId === RoleEnum.CASManager) {
      getAdministrators();
    }

  }, []);

  useEffect(() => {
    modalHack();
  }, [otherLocationModalOpen])

  const modalHack = () => {
    const locationModal = document.getElementById('locationModal');
    if (locationModal) {
      const modalContent = locationModal.querySelector('div[class*="Modal_content_"]') as any;
      if (modalContent) {
        modalContent.style.overflow = 'visible';
      }
    }
  };


  const onBackToRequestList = () => {
    if (userSession) {
      if (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector) {
        if (location.state && location.state.previousPage) {
          switch (location.state.previousPage) {
            case PreviousPage.DashboardPage: {
              history.push(dashboardRoute());
              break;
            }
            default: {
              history.push(dashboardRoute());
              break;
            }
          }
        }
        else {
          history.push(dashboardRoute());
        }
      }
      else {
        if (location.state && location.state.previousPage) {
          switch (location.state.previousPage) {
            case PreviousPage.NISOO2ProgramRequestListPage: {
              history.push(newProgramRequestListRoute());
              break;
            }
            case PreviousPage.ProgramRequestListPage: {
              history.push(programRequestListRoute());
              break;
            }
            default: {
              history.push(programRequestListRoute());
              break;
            }
          }
        }
        else {
          history.push(programRequestListRoute());
        }
      }
    }
  };

  const onEditRequest = () => {
    if (userSession && (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector)) {
      history.push(programRequestEditUrl(activeRequestId));
    }
  };

  const onOfficeEditRequest = () => {
    if (userSession && (userSession.roleId === RoleEnum.ASOOOffice || userSession.roleId === RoleEnum.CASOffice)) {
      setIsOfficeEditModalOpened(true);
    }
  };

  const handleCancelOfficeEditModal = () => {

    var envelopeClassificationRequestInit = {
      envelopeId: programRequestDetail.envelope?.id!,
      classificationMark: programRequestDetail.envelope?.classificationMark!,
      registryNumber: programRequestDetail.envelope?.registryNumber!,
      registrationDate: programRequestDetail.envelope?.registrationDate!

    };

    setEnvelopeClassificationRequest(envelopeClassificationRequestInit);

    setIsOfficeEditModalOpened(false);
  };

  const handleCancelOfficeEditConfirmModal = () => {
    setIsOfficeEditConfirmModalOpened(false);
  };

  const handleConfirmOfficeEditConfirmModal = async () => {
    await editEnvelope(envelopeClassificationRequest).then(() => {
      setIsOfficeEditSuccessModalOpened(true);
    });
  };

  const handleConfirmOfficeEditModal = () => {

    if (!envelopeClassificationRequest.classificationMark || !envelopeClassificationRequest.registryNumber || !envelopeClassificationRequest.registrationDate) {
      return;
    }

    setIsOfficeEditConfirmModalOpened(true);

  };

  const handleCloseOfficeEditSuccessModal = () => {
    setRequestClassificationMark(envelopeClassificationRequest.classificationMark);
    setRequestRegistryNumber(envelopeClassificationRequest.registryNumber);
    setRequestRegistrationDate(envelopeClassificationRequest.registrationDate);
    setIsOfficeEditSuccessModalOpened(false);
    setIsOfficeEditConfirmModalOpened(false);
    setIsOfficeEditModalOpened(false);
  }

  const handleConfirmOtherLocationModal = () => {

    if (!otherLocationRequest.institutionLocationDetailIds || otherLocationRequest.institutionLocationDetailIds.length === 0) {
      setOtherLocationValidationError(t("validations.requiredAtLeastOne"));
      return;
    }

    setOtherLocationConfirmModalOpen(true);

  };

  const handleCloseOtherLocationSuccessModal = () => {
    setOtherLocationSuccessModalOpen(false);
    setOtherLocationConfirmModalOpen(false);
    setOtherLocationModalOpen(false);

    onBackToRequestList();
  };

  const handleCancelOtherLocationConfirmModalOpen = () => {
    setOtherLocationConfirmModalOpen(false);
  };

  const handleConfirmOtherLocationConfirmModalOpen = async () => {

    await saveOtherLocations(otherLocationRequest).then(() => {
      setOtherLocationSuccessModalOpen(true);
    });
  };

  const handleCancelOtherLocationCancelModal = () => {
    setOtherLocationCancelModalOpen(false);
    setOtherLocationValidationError("");
  };

  const handleConfirmedOtherLocationCancelModal = () => {
    setOtherLocationCancelModalOpen(false);
    setOtherLocationModalOpen(false);
  };

  const handleEnvelopeClassificationMarkChange = (event: any) => {
    var classificationMark = event.target.value;

    const newEnvelopeClassificationRequest: EnvelopeClassificationRequest = {
      ...envelopeClassificationRequest,
      classificationMark: classificationMark
    };
    setEnvelopeClassificationRequest(newEnvelopeClassificationRequest);
  };

  const handleExecutionAddressChange = (event: any) => {
    const selectedValues = event.target.value as number[];

    const newOtherLocationRequest: OtherLocationRequest = {
      ...otherLocationRequest,
      institutionLocationDetailIds: selectedValues
    };

    if (selectedValues.length > 0) {
      setOtherLocationValidationError("");
    }
    else {
      setOtherLocationValidationError(t("validations.requiredAtLeastOne"));
    }

    setOtherLocationRequest(newOtherLocationRequest);
  };

  const handleEnvelopeRegistryNumberChange = (event: any) => {
    var registryNumber = event.target.value;

    const newEnvelopeClassificationRequest: EnvelopeClassificationRequest = {
      ...envelopeClassificationRequest,
      registryNumber: registryNumber
    };
    setEnvelopeClassificationRequest(newEnvelopeClassificationRequest);
  };

  const handleEnvelopeRegistrationDateChange = (event: any) => {
    var registrationDate = event.target.value;

    const newEnvelopeClassificationRequest: EnvelopeClassificationRequest = {
      ...envelopeClassificationRequest,
      registrationDate: registrationDate
    };

    setEnvelopeClassificationRequest(newEnvelopeClassificationRequest);

  };

  const onEditRequestMzo = () => {
    if (userSession && (userSession.roleId === RoleEnum.CASAdmin || userSession.roleId === RoleEnum.CASManager || userSession.roleId === RoleEnum.Helpdesk
      || userSession.roleId === RoleEnum.ASOOAdmin || userSession.roleId === RoleEnum.ASOOManager)) {
      if (location.state && location.state.previousPage) {
        history.push(programRequestMzoUrl(activeRequestId), { previousPage: location.state.previousPage });
      }
      else {
        history.push(programRequestMzoUrl(activeRequestId));
      }
    }
  };

  const onProgramRequestEnvelopePanelEditModeChanged = () => {
    setIsEnvelopeEditMode(!isEnvelopeEditMode);
  };



  const onCreateRequestResolution = (documentType: ResolutionDocumentType, isCorrection?: boolean) => {
    let captions = [] as string[];
    const resDoc = createResolutionDocument(documentType, programRequestDetail.envelope!.classificationMark);
    setResolutionDocument(() => resDoc);
    // Why do we have 2?
    setResolution(() => resDoc);
    const showComment = documentType !== ResolutionDocumentType.CommitteeMembership
      && documentType !== ResolutionDocumentType.InspectionReport
      && documentType !== ResolutionDocumentType.ExpertOpinionCorrection
      && documentType !== ResolutionDocumentType.ExecutionResolutionCorrection;
    setShowModalComment(() => showComment);

    if (documentType === ResolutionDocumentType.ExpertOpinion) {
      captions.push(t(`request.expertOpinionDocuments`));
      captions.push(t(`request.expertOpinionClassificationMark`));
      captions.push(t(`request.expertOpinionRegisterNumber`));
      captions.push(t(`request.expertOpinionIssueDate`));
    }
    else if (documentType === ResolutionDocumentType.ExpertOpinionCorrection) {
      captions.push(t(`request.correctExpertOpinionCaption`));
      captions.push(t(`request.expertOpinionClassificationMark`));
      captions.push(t(`request.expertOpinionRegisterNumber`));
      captions.push(t(`request.expertOpinionIssueDate`));
    }
    else if (documentType === ResolutionDocumentType.ExecutionResolution) {
      captions.push(t(`request.executionResolutionDocuments`));
      captions.push(t(`request.executionResolutionClassificationMark`));
      captions.push(t(`request.executionResolutionRegisterNumber`));
      captions.push(t(`request.executionResolutionIssueDate`));
    }
    else if (documentType === ResolutionDocumentType.ExecutionResolutionCorrection) {
      captions.push(t(`request.correctExecutionResolutionCaption`));
      captions.push(t(`request.executionResolutionClassificationMark`));
      captions.push(t(`request.executionResolutionRegisterNumber`));
      captions.push(t(`request.executionResolutionIssueDate`));
    }
    else if (documentType === ResolutionDocumentType.UnlockRequestASOO || documentType === ResolutionDocumentType.UnlockRequestMZO) {
      captions.push(t(`request.resolutionDocuments`));
      captions.push(t(`request.resolutionClassificationMark`));
      captions.push(t(`request.resolutionRegisterNumber`));
      captions.push(t(`request.unlockIssueDate`));
    }
    else if (documentType === ResolutionDocumentType.CommitteeMembership || documentType === ResolutionDocumentType.InspectionReport) {
      captions.push(t(`request.resolutionDocuments`));
      captions.push(t(`request.resolutionClassificationMark`));
      captions.push(t(`request.resolutionRegisterNumber`));
      captions.push(t(`request.committeeMembershipIssueDate`));
    }
    else if (documentType === ResolutionDocumentType.InstitutionBasicDataChangeResolution) {
      captions.push(t('request.executionResolutionModalCaption'));
      captions.push(t('request.executionResolutionClassificationMark'));
      captions.push(t('request.executionResolutionRegisterNumber'));
      captions.push(t('request.executionResolutionIssueDate'));
    }
    setResolutionModalCaptions(() => captions);

    setOpenResolutionModal(true);
  };

  const getResolutionConfirmModalCaption = () => {
    if (tmpResolution.documentTypeId === ResolutionDocumentType.ExpertOpinion) {
      if (tmpApproved === true) {
        return t("request.expertOpinionApprovedConfirmModalCaption");
      }
      else if (tmpApproved === false) {
        return t("request.expertOpinionDeclinedConfirmModalCaption");
      }
    }
    else if (tmpResolution.documentTypeId === ResolutionDocumentType.ExpertOpinionCorrection) {
      return t("request.expertOpinionCorrectionConfirmModalCaption");
    }
    else if (tmpResolution.documentTypeId === ResolutionDocumentType.ExecutionResolution || tmpResolution.documentTypeId === ResolutionDocumentType.InstitutionBasicDataChangeResolution) {
      if (tmpApproved === true) {
        return t("request.executionResolutionApprovedConfirmModalCaption");
      }
      else if (tmpApproved === false) {
        return t("request.executionResolutionDeclinedConfirmModalCaption");
      }

    }
    else if (tmpResolution.documentTypeId === ResolutionDocumentType.ExecutionResolutionCorrection) {
      return t("request.executionResolutionCorrectionConfirmModalCaption");
    }
    else if (tmpResolution.documentTypeId === ResolutionDocumentType.CommitteeMembership) {
      return t("request.committeeMembershipConfirmModalCaption");
    }
    else if (tmpResolution.documentTypeId === ResolutionDocumentType.InspectionReport) {
      return t("request.inspectionReportConfirmModalCaption");
    }
  };

  const handleCancelResolutionConfirmModal = () => {
    setOpenResolutionConfirmModal(false);
  };

  const handleCancelPausedRequestConfirmModal = () => {
    setOpenPausedRequestConfirmModal(false);
  };

  const handleConfirmPausedRequestConfirmModal = async () => {

    await submitPausedProgramRequest(programRequest.id);

    setOpenPausedRequestSuccessModal(true);
  };

  const handleConfirmedPausedRequestSuccessModal = () => {
    setRequestStatusId(ProgramRequestStatus.PausedMZOM);

    setOpenPausedRequestConfirmModal(false);
    setOpenPausedRequestSuccessModal(false);
  };

  const handleConfirmResolutionConfirmModal = async () => {

    await uploadResolutionDocument(tmpResolution);

    var createResolution: CreateResolutionDocumentRequest = {
      action: tmpApproved ? 1 : 2,
      documentId: tmpResolution.resolutionDocument?.id!,
      documentTypeId: tmpResolution.documentTypeId,
      classificationMark: tmpResolution.classificationMark!,
      registryNumber: tmpResolution.registryNumber,
      issueDate: tmpResolution.issueDate!,
      description: tmpResolution.description!,
      processingDeadline: tmpResolution.processingDeadline
    }

    if (tmpApproved) {
      if (tmpResolution.documentTypeId === ResolutionDocumentType.ExpertOpinion) {
        setConfirmationMessage(t("request.approveExpertOpinionMessage", { id: activeRequestId }));
      }
      else if (tmpResolution.documentTypeId === ResolutionDocumentType.ExpertOpinionCorrection) {
        setConfirmationMessage(t("request.expertOpinionCorrectionMessage", { id: activeRequestId }));
      }
      else if (tmpResolution.documentTypeId === ResolutionDocumentType.ExecutionResolutionCorrection) {
        setConfirmationMessage(t("request.executionResolutionCorrectionMessage", { id: activeRequestId }));
      }
      else if (tmpResolution.documentTypeId === ResolutionDocumentType.CommitteeMembership) {
        setConfirmationMessage(t("request.approveCommitteeMembershipModalMessage", { id: activeRequestId }));
      }
      else if (tmpResolution.documentTypeId === ResolutionDocumentType.InspectionReport) {
        setConfirmationMessage(t("request.inspectionReportModalMessage", { id: activeRequestId }));
      }
      else {
        setConfirmationMessage(t("request.approveRequestModalMessage", { id: activeRequestId }));
      }
    }
    else {
      if (tmpResolution.documentTypeId === ResolutionDocumentType.ExpertOpinion || tmpResolution.documentTypeId === ResolutionDocumentType.ExpertOpinionCorrection) {
        setConfirmationMessage(t("request.cancelExpertOpinionMessage", { id: activeRequestId }));
      }
      else if (tmpResolution.documentTypeId === ResolutionDocumentType.CommitteeMembership) {
        setConfirmationMessage(t("request.rejectCommitteeMembershipModalMessage", { id: activeRequestId }));
      }
      else {
        setConfirmationMessage(t("request.rejectRequestModalMessage", { id: activeRequestId }));
      }
    }

    await createProgramRequestResolution(programRequest.id, createResolution).then(() => {
      setOpenStatusChangeModal(true);
    });

    // Reset the document. As this is asynchronous, the new document may take some time to be set.
    // Let's not show the previous document.      
    setResolutionDocument(createResolutionDocument(ResolutionDocumentType.ExpertOpinion, programRequestDetail.envelope!.classificationMark));
    setResolution(resolutionDocument);
    setIsCorrectionResolution(false);
  };

  const getResolutionModalElementCaption = (element: string) => {
    if (resolutionDocument.documentTypeId === ResolutionDocumentType.ExpertOpinion) {
      if (element === "confirmText") {
        return t("request.judgeRequestModalConfirm");
      }
      if (element === "rejectText") {
        return t("request.judgeRequestModalReject");
      }
      if (element === "caption") {
        return t("request.judgeRequestModalCaption");
      }
      if (element === "title") {
        return t("request.judgeRequestModalTitle");
      }
    }
    else if (resolutionDocument.documentTypeId === ResolutionDocumentType.ExpertOpinionCorrection) {
      if (element === "confirmText") {
        return t("request.correctExpertOpinion");
      }
      if (element === "rejectText") {
        return undefined;
      }
      if (element === "caption") {
        return t("request.correctExpertOpinionCaption");
      }
      if (element === "title") {
        return t("request.correctExpertOpinionCaption");
      }
    }
    else if (resolutionDocument.documentTypeId === ResolutionDocumentType.ExecutionResolution || resolutionDocument.documentTypeId === ResolutionDocumentType.InstitutionBasicDataChangeResolution) {
      if (element === "confirmText") {
        return t("request.judgeRequestModalConfirm");
      }
      if (element === "rejectText") {
        return t("request.executionResolutionModalReject");
      }
      if (element === "caption") {
        return t("request.executionResolutionModalCaption");
      }
      if (element === "title") {
        return t("request.executionResolutionModalTitle");
      }
    }
    else if (resolutionDocument.documentTypeId === ResolutionDocumentType.ExecutionResolutionCorrection) {
      if (element === "confirmText") {
        return t("request.correctExecutionResolution");
      }
      if (element === "rejectText") {
        return undefined;
      }
      if (element === "caption") {
        return t("request.correctExecutionResolutionCaption");
      }
      if (element === "title") {
        return t("request.correctExecutionResolutionCaption");
      }
    }
    else if (resolutionDocument.documentTypeId === ResolutionDocumentType.UnlockRequestASOO ||
      resolutionDocument.documentTypeId === ResolutionDocumentType.UnlockRequestMZO) {
      if (element === "confirmText")
        return t("request.unlockRequestModalConfirm");
      if (element === "caption")
        return t("request.unlockRequestModalCaption");
      if (element === "title")
        return t("request.unlockRequestModalTitle");
    }
    else if (resolutionDocument.documentTypeId === ResolutionDocumentType.CommitteeMembership) {
      if (element === "confirmText")
        return t("request.committeeMembershipRequest");
      if (element === "caption")
        return t("request.committeeMembershipModalCaption");
      if (element === "title")
        return t("request.committeeMembershipModalTitle");
    }
    else if (resolutionDocument.documentTypeId === ResolutionDocumentType.InspectionReport) {
      if (element === "confirmText")
        return t("request.inspectionReportRequest");
      if (element === "caption")
        return t("request.inspectionReportModalCaption");
      if (element === "title")
        return t("request.inspectionReportModalTitle");
    }
    return "";
  }

  const onCreateRequestStatus = (newRequestStatusId: ProgramRequestStatus) => {
    switch (newRequestStatusId) {
      case ProgramRequestStatus.UnlockedASOO:
        setUnloackStatus(ProgramRequestStatus.UnlockedASOO);
        setOpenStatusUnlockModal(true);
        break;
      case ProgramRequestStatus.UnlockedMZO:
        setUnloackStatus(ProgramRequestStatus.UnlockedMZO);
        setOpenStatusUnlockModal(true);
        break;
      case ProgramRequestStatus.Opened:
        setOpenStatusEditApprovedModal(true);
        break;
      case ProgramRequestStatus.SubmittedMZO:
        setOpenStatusSubmitMZOModal(true);
        break;
    }
  };

  const undoProgramRequestChange = () => {
    setUndoProgramRequestChangeModal(true);
  }

  function getResolutionDocumentCaption(documentTypeId: ResolutionDocumentType, fieldName?: string): string {
    if (!fieldName) {
      switch (documentTypeId) {
        case ResolutionDocumentType.ExpertOpinion:
          return t("request.expertOpinionDocuments");
        case ResolutionDocumentType.ExpertOpinionCorrection:
          return t("request.correctExpertOpinionCaption");
        case ResolutionDocumentType.ExecutionResolution:
          return t("request.executionResolutionDocuments");
        case ResolutionDocumentType.ExecutionResolutionCorrection:
          return t("request.correctExecutionResolutionCaption");
        case ResolutionDocumentType.OtherLegalEntityLocation:
          return t("request.otherLegalEntityResolutionDocuments");
        case ResolutionDocumentType.UnlockRequestASOO:
          return t("request.unlockASOOResolutionDocuments");
        case ResolutionDocumentType.UnlockRequestMZO:
          return t("request.unlockMZOResolutionDocuments");
        case ResolutionDocumentType.CommitteeMembership:
          return t("request.committeeMembershipModalCaption");
        case ResolutionDocumentType.InspectionReport:
          return t("request.inspectionReportModalCaption");
        case ResolutionDocumentType.OtherLegalEntityLocationDecision:
          return t("otherLegalEntityLocation.ministryConsentButton");
        case ResolutionDocumentType.ForeignLanguageDecision:
          return t("teacherLanguage.ministryConsentButton");
        case ResolutionDocumentType.HarmonizationDecisionASOO:
          return t("harmonization.agencyDocument");
        // case ResolutionDocumentType.HarmonizationDecisionMZO:
        //   return t("harmonization.ministryConsentButton");
        case ResolutionDocumentType.ArchiveASOO:
          return t("request.revokeApproveRequestASOODocument");
        case ResolutionDocumentType.ArchiveMZO:
          return t("request.revokeApproveRequestMZODocument");
        case ResolutionDocumentType.OtherLocationDecision:
          return t("otherLocations.ministryConsentButton");
        case ResolutionDocumentType.InstitutionBasicDataChangeResolution:
          return t("request.institutionBasicDataResolutionDocuments");
      }
    }
    else if (fieldName === "Document") {
      switch (documentTypeId) {
        case ResolutionDocumentType.ExpertOpinion:
          return t("request.expertOpinionDocuments");
        case ResolutionDocumentType.ExpertOpinionCorrection:
          return t("request.correctExpertOpinionCaption");
          break;
        case ResolutionDocumentType.ExecutionResolution:
          return t("request.executionResolutionDocuments");
        case ResolutionDocumentType.ExecutionResolutionCorrection:
          return t("request.correctExecutionResolutionCaption");
          break;
        default:
          return t("request.resolutionDocuments");
      }
    }
    else if (fieldName === "ClassificationMark") {
      switch (documentTypeId) {
        case ResolutionDocumentType.ExpertOpinion:
        case ResolutionDocumentType.ExpertOpinionCorrection:
          return t("request.expertOpinionClassificationMark");
        case ResolutionDocumentType.ExecutionResolution:
        case ResolutionDocumentType.ExecutionResolutionCorrection:
          return t("request.executionResolutionClassificationMark");
        default:
          return t("request.resolutionClassificationMark");
      }
    }
    else if (fieldName === "RegisterNumber") {
      switch (documentTypeId) {
        case ResolutionDocumentType.ExpertOpinion:
        case ResolutionDocumentType.ExpertOpinionCorrection:
          return t("request.expertOpinionRegisterNumber");
        case ResolutionDocumentType.ExecutionResolution:
        case ResolutionDocumentType.ExecutionResolutionCorrection:
          return t("request.executionResolutionRegisterNumber");
        default:
          return t("request.resolutionRegisterNumber");
      }
    }
    else if (fieldName === "IssueDate") {
      switch (documentTypeId) {
        case ResolutionDocumentType.ExpertOpinion:
        case ResolutionDocumentType.ExpertOpinionCorrection:
          return t("request.expertOpinionIssueDate");
        case ResolutionDocumentType.ExecutionResolution:
        case ResolutionDocumentType.ExecutionResolutionCorrection:
          return t("request.executionResolutionIssueDate");
        case ResolutionDocumentType.CommitteeMembership:
        case ResolutionDocumentType.InspectionReport:
          return t("request.committeeMembershipIssueDate");
        default:
          return t("request.resolutionIssueDate");
      }
    }
    return ""
  }

  const handleCancelResolutionModal = async () => {
    setOpenCancelModal(true);
    // setOpenResolutionModal(false);
    //   // Reset the document. As this is asynchronous, the new document may take some time to be set.
    //   // Let's not show the previous document.
    // setResolutionDocument(createResolutionDocument(ResolutionDocumentType.ExpertOpinion, programRequestDetail.envelope!.classificationMark));
    // setResolution(resolutionDocument);
  }

  const handleCancelUnlockStatusModal = async () => {
    setOpenStatusUnlockModal(false);
  }

  const handleCancelSubmitMZOStatusModal = async () => {
    setOpenStatusSubmitMZOModal(false);
  }

  const handleStatusChangeMessageModal = async () => {
    setOpenStatusChangeModal(false);
    setOpenResolutionConfirmModal(false);
    setOpenResolutionModal(false);

    setRequestStatusId(requestStatusId + 1);
  }

  const handleCancelEditApprovedStatusModal = async () => {
    setOpenStatusEditApprovedModal(false);
  }

  const handleLearningSetCodeModal = async () => {
    setOpenLearningSetCodeModal(false);
  }

  const handleUndoProgramRequestChange = async () => {
    setUndoProgramRequestChangeModal(false);
  }

  const handleConfirmedUndoProgramRequestChangeModal = async () => {
    setUndoProgramRequestChangeModal(false);

    await undoProgramRequestChanges(programRequest.id).then(() => {
      setConfirmationMessage(t("request.cancelChangesRequestModalMessage", { id: programRequest.id }));
      setOpenStatusChangeModal(true);
    });
  }

  const handleConfirmedResolutionModal = async (approved: boolean, resolution: ExecutionResolutionDocument) => {

    if (programRequest && programRequest.id) {

      setTmpApproved(approved);
      setTmpResolution(resolution);

      if (resolution.documentTypeId === ResolutionDocumentType.UnlockRequestASOO || resolution.documentTypeId === ResolutionDocumentType.UnlockRequestMZO) {

        setOpenUnlockConfirmationModal(true);
        return;
      }

      setOpenResolutionConfirmModal(true);



    }
  }

  const uploadResolutionDocument = async (resolution: ExecutionResolutionDocument) => {
    if (resolution.resolutionDocument && resolution.resolutionDocument.id === -1) {
      var resolutionDocumentUploadRequest: DocumentUploadRequest = {
        document: resolution.resolutionDocument!.file!,
        documentTypeId: DocumentType.ProgramExecutionResolution,        
        resolutionDocumentTypeId: resolution.documentTypeId
      };

      await uploadDocument(resolutionDocumentUploadRequest).then((idDoc) => {
        var resolutionDocument = resolution.resolutionDocument;
        resolutionDocument!.id = idDoc;
        setResolution((prev) => ({
          ...prev,
          resolutionDocument: resolutionDocument
        }));
      });
    }
  }

  const handleConfirmedStatusModal = async (requestStatusId: ProgramRequestStatus, description: string, userSelection: number[] | null) => {    
    switch (requestStatusId) {
      case ProgramRequestStatus.UnlockedASOO:
      case ProgramRequestStatus.UnlockedMZO:
        setOpenStatusUnlockModal(false);
        break;
      case ProgramRequestStatus.Opened:
        setOpenStatusEditApprovedModal(false);
        break;
      case ProgramRequestStatus.SubmittedASOO:
        setOpenStatusEditApprovedModal(false);
        break;
      case ProgramRequestStatus.SubmittedMZO:
        setOpenStatusSubmitMZOModal(false);
        break;
      case ProgramRequestStatus.CancelledASOO:
      case ProgramRequestStatus.CancelledMZO:
        setOpenStatusRevokeModal(false);
        break;
    }
    var selectedEnrollmentConditions: string[] = [];

    var activeRequest = programRequestCorrection ? programRequestCorrection : programRequestDetail;

    if (activeRequest && userSelection && activeRequest.otherEnrollmentConditions) {
      for (let i = 0; i < userSelection.length; i++) {
        if (userSelection[i] === 1) {
          selectedEnrollmentConditions.push(activeRequest.otherEnrollmentConditions[i]);
        }
      }
    }

    if (requestStatusId === ProgramRequestStatus.CancelledASOO
      || requestStatusId === ProgramRequestStatus.CancelledMZO) {
      if (programRequest.requestStatusId === ProgramRequestStatus.SubmittedASOO
        || programRequest.requestStatusId === ProgramRequestStatus.UnlockedASOO)
        requestStatusId = ProgramRequestStatus.CancelledASOO;
      else
        requestStatusId = ProgramRequestStatus.CancelledMZO;

    }

    var createStatus: CreateProgramRequestStatus = {
      requestId: programRequest.id,
      requestStatusId: requestStatusId,
      description: description,
      enrollmentConditions: selectedEnrollmentConditions
    }

    await setProgramRequestStatus(createStatus).then(() => {
      switch (requestStatusId) {
        case ProgramRequestStatus.Approved:
          setConfirmationMessage(t("request.approveRequestModalMessage", { id: activeRequestId }));
          break;
        case ProgramRequestStatus.UnlockedASOO:
        case ProgramRequestStatus.UnlockedMZO:
          setConfirmationMessage(t("request.unlockRequestModalMessage", { id: activeRequestId }));
          break;
        case ProgramRequestStatus.Rejected:
          setConfirmationMessage(t("request.rejectRequestModalMessage", { id: activeRequestId }));
          break;
        case ProgramRequestStatus.Opened:
          setConfirmationMessage(t("request.cancelApproveRequestModalMessage", { id: activeRequestId }));
          break;
        case ProgramRequestStatus.SubmittedASOO:
          setConfirmationMessage(t("request.statusASOOSubmitModalMessage", { id: activeRequestId }));
          break;
        case ProgramRequestStatus.SubmittedMZO:
          setConfirmationMessage(t("request.statusMZOSubmitModalMessage", { id: activeRequestId }));
          break;
        case ProgramRequestStatus.CancelledASOO:
        case ProgramRequestStatus.CancelledMZO:
          setConfirmationMessage(t("request.revokeApproveRequestModalMessage", { id: activeRequestId }));
          break;
      }
      setOpenStatusChangeModal(true);
    });
  }

  const fillLocations = () => {
    var tempLocations: CodeBook[];

    var headquartersElement = { id: -1, name: `${institution.address}, ${institution.town.name}, ${institution.town.municipalityName}` } as CodeBook;

    tempLocations = institution.locations.filter(x => !programRequestDetail.outsideHeadquarterIds.some(y => y === x.id) && x.address && x.activityState === LocationState.Active || (x.deactivateDate && new Date(x.deactivateDate) > new Date()))
      .map((a => { return { id: a.locationDetailId, name: `${a.address}, ${a.town.name}, ${a.town.municipalityName}` } }));

    tempLocations = tempLocations.filter(x => !programRequestDetail.otherLocations.some(y => y.institutionLocationDetailId === x.id));

    if (!programRequestDetail.locationHeadquarter) {
      tempLocations.unshift(headquartersElement);
    }

    setFilteredLocations(tempLocations);
  };

  const handleProgramRequestTypeClick = () => {
    switch (programRequestType) {
      case ProgramRequestType.ConsentForExecutionAtTheLocationOfAnotherLegalEntityMZO:
        setOtherLegalEntityLocation(createOtherLegalEntityLocation);
        setOtherLegalEntityLocationModalOpen(true);
        break;
      case ProgramRequestType.ConsentForExecutionInAForeignLanguage:
        setIsConsentForeignLanguageType(true);
        setTeacherLanguageMandatory();
        break;
      // case ProgramRequestType.ConsentForHarmonizationMZO:
      //   setIsConsentForHarmonization(true);
      //   break;
      case ProgramRequestType.ConsentForHarmonizationASOO:
        setIsConsentForHarmonization(true);
        break;
      case ProgramRequestType.RequestForExecutionAtAnotherLocation:

        fillLocations();
        //default objekt za kreiranje!!
        setOtherLocationRequest((prev) => ({
          ...prev,
          programRequestId: programRequest.id,
          programRequestDetailId: programRequestDetail.id,
          institutionLocationDetailIds: []
        }));

        setOtherLocationValidationError("");

        setOtherLocationModalOpen(true);

        break;
    }
  };

  const handleOtherLegalEntityLocationChange = (e: any) => {
    const item = e.target.value as OtherLegalEntityLocation;
    setOtherLegalEntityLocation(item);
  };

  const getErrorForPath = (path: string): string | undefined => {
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, '');           // strip a leading dot
    var pathKeys = path.split('.');
    var result = errors as any;

    for (let i = 0; i < pathKeys.length; ++i) {
      var key = pathKeys[i];
      if (result && typeof (result) === 'object' && result.hasOwnProperty(key)) {
        result = result[key] as any;
      } else {
        return undefined;
      }
    }
    return result as string;
  }

  const handleConfirmedOtherLegalEntityLocationModal = async (item: OtherLegalEntityLocation) => {
    setOtherLegalEntityLocationModalOpen(false);

    await uploadOtherLegalEntityLocationDocuments(item);

    const result = await saveOtherLegalEntityLocation(programRequest.id, item);
    onBackToRequestList();
  };

  const handleConfirmedOtherLegalEntityLocationModalV2 = async (item: OtherLegalEntityLocation) => {
    setOtherLegalEntityLocation(item);
    setSaveConfirmModalLocationState(ConfirmModalState.Confirm)
  };

  const doSaveOtherLegalEntityLocation = async () => {
    setSaveConfirmModalLocationState(ConfirmModalState.Closed);
    setOtherLegalEntityLocationModalOpen(false);

    await uploadOtherLegalEntityLocationDocuments(otherLegalEntityLocation!);

    await saveOtherLegalEntityLocation(programRequest.id, otherLegalEntityLocation!).then(() => {
      setSaveConfirmModalLocationState(ConfirmModalState.Message);
    });
  };

  const uploadOtherLegalEntityLocationDocuments = async (item: OtherLegalEntityLocation) => {
    if (item.programExecutionRequestDocument && item.programExecutionRequestDocument.id === -1) {
      var programExecutionRequestDocumentRequest: DocumentUploadRequest = {
        document: item.programExecutionRequestDocument!.file!,
        documentTypeId: DocumentType.OtherLegalEntityProgramExecutionRequest
      };
      await uploadDocument(programExecutionRequestDocumentRequest).then((idDoc) => {
        item.programExecutionRequestDocument!.id = idDoc;
      });
    }
    if (item.ministryConsentDocument && item.ministryConsentDocument.id === -1) {
      var ministryConsentDocumentRequest: DocumentUploadRequest = {
        document: item.ministryConsentDocument!.file!,
        documentTypeId: DocumentType.OtherLegalEntityMinistryConsent
      };
      await uploadDocument(ministryConsentDocumentRequest).then((idDoc) => {
        item.ministryConsentDocument!.id = idDoc;
      });
    }
    if (item.personnelConditionsDocument && item.personnelConditionsDocument.id === -1) {
      var personnelConditionsDocumentRequest: DocumentUploadRequest = {
        document: item.personnelConditionsDocument!.file!,
        documentTypeId: DocumentType.OtherLegalEntityPersonnelConditions        
      };
      await uploadDocument(personnelConditionsDocumentRequest).then((idDoc) => {
        item.personnelConditionsDocument!.id = idDoc;
      });
    }
  };

  const handleCancelOtherLegalEntityLocationModal = async () => {
    setOtherLegalEntityLocationModalOpen(false);
    setOtherLegalEntityLocation(undefined);
  };

  const handleConsentCreate = (documentType: ResolutionDocumentType) => {
    setConsent(() => createResolutionDocument(documentType, programRequestDetail.envelope!.classificationMark));
    setOpenConsentModal(true);
  };

  const handleConsentCancel = () => {
    setOpenConsentModal(false);
    setConsent(undefined);
  };

  const handleConsentSave = async (c: ExecutionResolutionDocument) => {
    await createConsent(programRequest.id, c);
  };

  const handleConsentFinish = () => {
    onBackToRequestList();
  };

  const handleCancelCancelModal = async () => {
    setOpenCancelModal(false);
  };

  const handleCancelConfirmationModal = async () => {
    setOpenUnlockConfirmationModal(false);
  };

  //ovo će raditi samo za otključavanje ali je za svaki slučaj pušten i "višak" koda
  const handleConfirmConfirmationModal = async () => {
    if (programRequest && programRequest.id) {

      await uploadResolutionDocument(tmpResolution);

      var createResolution: CreateResolutionDocumentRequest = {
        action: tmpApproved ? 1 : 2,
        documentId: tmpResolution.resolutionDocument?.id!,
        documentTypeId: tmpResolution.documentTypeId,
        classificationMark: tmpResolution.classificationMark!,
        registryNumber: tmpResolution.registryNumber,
        issueDate: tmpResolution.issueDate!,
        description: tmpResolution.description!,
        processingDeadline: tmpResolution.processingDeadline
      }
      setOpenUnlockConfirmationModal(false);
      setOpenResolutionModal(false);
      if (tmpApproved) {
        if (tmpResolution.documentTypeId === ResolutionDocumentType.ExpertOpinion || tmpResolution.documentTypeId === ResolutionDocumentType.ExpertOpinionCorrection) {
          setConfirmationMessage(t("request.approveExpertOpinionMessage", { id: activeRequestId }));
        }
        if (tmpResolution.documentTypeId === ResolutionDocumentType.UnlockRequestASOO || tmpResolution.documentTypeId === ResolutionDocumentType.UnlockRequestMZO) {
          setConfirmationMessage(t("request.unlockRequestModalMessage", { id: activeRequestId }));
        }
        else {
          setConfirmationMessage(t("request.approveRequestModalMessage", { id: activeRequestId }));
        }
      }
      else {
        if (tmpResolution.documentTypeId === ResolutionDocumentType.ExpertOpinion || tmpResolution.documentTypeId === ResolutionDocumentType.ExpertOpinionCorrection) {
          setConfirmationMessage(t("request.cancelExpertOpinionMessage", { id: activeRequestId }));
        }
        else {
          setConfirmationMessage(t("request.rejectRequestModalMessage", { id: activeRequestId }));
        }
      }

      await createProgramRequestResolution(programRequest.id, createResolution).then(() => {
        setOpenStatusChangeModal(true);
      });

      // Reset the document. As this is asynchronous, the new document may take some time to be set.
      // Let's not show the previous document.
      setResolutionDocument(createResolutionDocument(ResolutionDocumentType.ExpertOpinion, programRequestDetail.envelope!.classificationMark));
      setResolution(resolutionDocument);
      setIsCorrectionResolution(false);
    }

  };

  const handleToggleCancelAssignDifferentAdministratorModal = () => {
    setAssignAdministratorRequest(createDefaultAssignAdministratorRequest);
    setIsAssignDifferentAdministratorModalOpened(false);
  };

  const handleToggleConfirmAssignDifferentAdministratorModal = () => {
    if (assignAdministratorRequest.administratorId === undefined) {
      return;
    }
    setIsConfirmAssignAdministratorModalOpened(true);
  };

  const handleAdministratorIdChange = (e: any) => {
    let administratorId: number | undefined = undefined;
    if (e.target.value) {
      administratorId = Number.parseInt(e.target.value);
    }
    else {
      administratorId = undefined;
      setAdministratorConfirmationMessage("");
    }
    const newAdministratorRequest: AssignAdministratorRequest = {
      ...assignAdministratorRequest,
      administratorId: administratorId
    };
    setAssignAdministratorRequest(newAdministratorRequest);

    if (administratorId !== undefined && administratorId !== null) {
      var selectedAdmin = filteredAdministrators.find(a => a.userId === administratorId);

      if (selectedAdmin) {
        setAdministratorConfirmationMessage(t("request.assignAdministratorConfirmModalMessage", { firstName: selectedAdmin.firstName, lastName: selectedAdmin.lastName }));
        setSelectedAdminName(selectedAdmin.name);
      }
    }
  };

  const handleAdministratorSearch = async (search: AutocompleteSearchData) => {
    if (search) {
      const filteredAdmins = filteredAdministrators.filter(a => a.name.toLowerCase().includes(search!.text!.toLowerCase()));
      return {
        valueProp: "userId",
        textProp: "name",
        data: filteredAdmins
      } as SelectData<AppUserRole>
    }
    return {
      valueProp: "userId",
      textProp: "name",
      data: filteredAdministrators
    } as SelectData<AppUserRole>
  };

  const handleCancelConfirmAssignAdministratorModal = () => {
    setIsConfirmAssignAdministratorModalOpened(false);
  };

  const handleConfirmAssignAdministratorModal = async () => {
    await reassignAdministrator(assignAdministratorRequest);

    setRequestAdministrator(selectedAdminName);

    setIsConfirmAssignAdministratorModalOpened(false);
    setIsAssignDifferentAdministratorModalOpened(false);

    setAssignAdministratorRequest(createDefaultAssignAdministratorRequest);

  };

  const handleConfirmedCancelModal = async () => {
    setOpenCancelModal(false);

    // setOpenStatusUnlockModal(false);
    setOpenResolutionModal(false);

    // Reset the document. As this is asynchronous, the new document may take some time to be set.
    // Let's not show the previous document.      
    setResolutionDocument(createResolutionDocument(ResolutionDocumentType.ExpertOpinion, programRequestDetail.envelope!.classificationMark));

    setResolution(resolutionDocument);
  };

  const onSendReqest = async (requestStatusId: ProgramRequestStatus) => {
    if (programRequest) {
      var createStatus: CreateProgramRequestStatus = {
        requestId: programRequest.id,
        requestStatusId: requestStatusId,
        description: "",
        enrollmentConditions: []
      }
      await createSingleProgramRequestGroup(createStatus).then(() => {
        switch (requestStatusId) {
          case ProgramRequestStatus.SubmittedASOO:
            setConfirmationMessage(t("request.changeStatusToASOOSubmit", { id: programRequest.id }));
            break;
        }
        setOpenStatusChangeModal(true);
      });
    }
  }


  const validateLearningSetCode = () => {
    if (((programRequestDetail.qualificationTypeId ?? 0) & 1) === 0) {
      const checkCorrectionLearningSet = (module: number, learningSet: number) => {
        if (programRequestCorrection && programRequestCorrection.modules && programRequestCorrection.modules.length > module) {
          let correctionModule = programRequestCorrection.modules[module];

          if (correctionModule.learningSets && correctionModule.learningSets.length > learningSet) {
            return correctionModule.learningSets[learningSet].code.length > 0;
          }
        }
        return false;
      }

      if (programRequestDetail.modules && programRequestDetail.modules.length > 0) {
        for (let i = 0; i < programRequestDetail.modules.length; i++) {
          for (let j = 0; j < programRequestDetail.modules[i].learningSets.length; j++) {
            if (programRequestDetail.modules[i].learningSets[j].code.length === 0 && !checkCorrectionLearningSet(i, j)) {

              setLearningSetCodeMessage(t("request.learningSetCodeValidation", { name: programRequestDetail.modules[i].learningSets[j].name }))
              setOpenLearningSetCodeModal(true);
              return false;
            }
          }
        }
      }
    }
    return true;
  }

  const onDownloadPdf = async () => {
    await downloadProgramRequestPdf(programRequest.id);
  }

  const onSubmitPausedRequest = () => {
    setOpenPausedRequestConfirmModal(true);
  };

  const getLearningTotal = (): number | undefined => {
    let total = (Number(programRequestCorrection?.guidedLearningDuration) || 0) +
      (Number(programRequestCorrection?.independentLearningDuration) || 0) +
      (Number(programRequestCorrection?.workLearningDuration) || 0);
    return total === 0 ? undefined : total;
  }

  const userCanEditProgramRequest = (): boolean => {
    if (userSession) {
      if (userSession.roleId === RoleEnum.CASAdmin || userSession.roleId === RoleEnum.CASManager || userSession.roleId === RoleEnum.Helpdesk) {
        return programRequest.requestStatusId === ProgramRequestStatus.SubmittedMZO;
      }
      if (userSession.roleId === RoleEnum.ASOOAdmin || userSession.roleId === RoleEnum.ASOOManager) {
        return programRequest.requestStatusId === ProgramRequestStatus.SubmittedASOO;
      }
    }
    return false;
  }

  // interface ProgramRequestTeacher {	
  //   requestId: number;	
  //   Oib: string;	
  //   FirstName?: string;	
  //   LastName?: string;	
  //   classEnsamble?: string;	
  //   statementDocument?: DocumentData;	
  //   diplomaDocument?: DocumentData;	
  //   additionalDocumentation?: DocumentData;	
  // }

  const handleSaveClicked = () => {
    const isValid = doValidations();    
    if (isValid) {
      if (isConsentForeignLanguageType) {
        setSaveConfirmModalConfirmButton(t("harmonization.confirm"));
        setSaveConfirmModalCancelButton(t("common.cancel"));
        setSaveConfirmModalDescription(t("harmonization.descriptionConsent"));
        setSaveConfirmModalTitle(t("teacherLanguage.ministryConsentButton"));
        setSaveConfirmModalMessage(t("teacherLanguage.message"));
        setSaveConfirmModalSuccessMessage(t("teacherLanguage.successMessage", { id: programRequest.id }));
      } else if (isConsentForHarmonization) {
        setSaveConfirmModalConfirmButton(t("harmonization.confirm"));
        setSaveConfirmModalCancelButton(t("common.cancel"));
        setSaveConfirmModalDescription(t("harmonization.descriptionConsent"));
        setSaveConfirmModalTitle(t("harmonization.ministryConsentButton"));
        setSaveConfirmModalMessage(t("harmonization.message"));
        setSaveConfirmModalSuccessMessage(t("harmonization.successMessage", { id: programRequest.id }));
      }
      else if(subsequentTeacherAddition){
        setSaveConfirmModalConfirmButton(t("common.yesSaveChanges"));
        setSaveConfirmModalCancelButton(t("common.cancel"));        
        setSaveConfirmModalDescription(t("harmonization.descriptionConsent"));
        setSaveConfirmModalTitle(t("request.subsequentTeacherModalTitle"));
        setSaveConfirmModalMessage(t("request.subsequentTeacherSaveMessage"));
        setSaveConfirmModalSuccessMessage(t("request.subsequentTeacherSuccessMessage", { id: programRequest.id }));
      }
      setSaveConfirmModalState(ConfirmModalState.Confirm);      
    }
  };

  const onTakeOverProcessingClick = async (envelopeId: number) => {
    await takeOverProcessing(envelopeId);
    if (userSession) {
      setRequestAdministrator(userSession.name);
    }
  };

  const onAssignDifferentAdministratorClick = () => {

    const newAssignAdministratorRequest: AssignAdministratorRequest = {
      ...assignAdministratorRequest,
      envelopeId: programRequestDetail.envelope!.id
    };

    setAssignAdministratorRequest(newAssignAdministratorRequest);
    setIsAssignDifferentAdministratorModalOpened(true);
  };

  const setTeacherLanguageMandatory = () => {
    const arr = programRequestDetail.programRequestTeachers.slice();

    for (var i = 0; i < arr.length; i++) {
      const item = arr[i];

      const updatedItem: ProgramRequestTeacher = {
        ...item,
        isLanguageMandatory: true
      };

      arr[i] = updatedItem;
    }

    const prd: ProgramRequestDetail = {
      ...programRequestDetail,
      programRequestTeachers: arr,
    };

    setProgramRequestDetail(() => prd);

  };

  const handleProgramRequestDetailChange = (detail: ProgramRequestDetail) => {
    setProgramRequestDetail(detail);
  };
  const doSaveTeacherDocuments = async () => {
    const arr = programRequestDetail.programRequestTeachers.slice();
    for (var i = 0; i < arr.length; i++) {
      const item = arr[i];
      var additionalDocumentId: number | undefined = item.additionalDocumentation?.id;
      var diplomaId: number | undefined = item.diplomaDocument?.id;
      var statementId: number | undefined = item.statement?.id;
      if (additionalDocumentId === -1 && item.additionalDocumentation?.file) {
        var documentUploadRequest: DocumentUploadRequest = {
          document: item.additionalDocumentation.file,
          documentTypeId: DocumentType.TeacherAdditional,
        };
        additionalDocumentId = await uploadDocument(documentUploadRequest);
      }
      if (diplomaId === -1 && item.diplomaDocument?.file) {
        var documentUploadRequest: DocumentUploadRequest = {
          document: item.diplomaDocument.file,
          documentTypeId: DocumentType.TeacherDiploma,
        };
        diplomaId = await uploadDocument(documentUploadRequest);
      }
      if (statementId === -1 && item.statement?.file) {
        var documentUploadRequest: DocumentUploadRequest = {
          document: item.statement.file,
          documentTypeId: DocumentType.TeacherStatement,
        };
        statementId = await uploadDocument(documentUploadRequest);
      }

      if (item.languages && item.languages.length > 0) {
        var langArr = item.languages.slice();
        for (var j = 0; j < langArr.length; j++) {
          const langItem = langArr[j];

          var certificationDocumentId: number | undefined = langItem.certificationDocument?.id;

          if (certificationDocumentId === -1 && langItem.certificationDocument?.file) {
            var documentUploadRequest: DocumentUploadRequest = {
              document: langItem.certificationDocument.file,
              documentTypeId: DocumentType.TeacherLanguageCertification,
            };
            certificationDocumentId = await uploadDocument(documentUploadRequest);
          }

          const updatedLangItem: TeacherLanguage = {
            ...langItem,
            certificationDocument: langItem.certificationDocument ? { ...langItem.certificationDocument, id: certificationDocumentId, file: undefined } : undefined
          };

          langArr[j] = updatedLangItem;
          item.languages[j] = langArr[j];
        }
      }

      const updatedItem: ProgramRequestTeacher = {
        ...item,
        additionalDocumentation: item.additionalDocumentation ? { ...item.additionalDocumentation, id: additionalDocumentId, file: undefined } : undefined,
        diplomaDocument: item.diplomaDocument ? { ...item.diplomaDocument, id: diplomaId, file: undefined } : undefined,
        statement: item.statement ? { ...item.statement, id: statementId, file: undefined } : undefined,
      };
      arr[i] = updatedItem;

    }

    const prd: ProgramRequestDetail = {
      ...programRequestDetail,
      programRequestTeachers: arr,
    };
    setProgramRequestDetail(() => prd);

    return arr;
  };

  const uploadCurriculumProgramDocument = async () => {
    if(programRequestDetail.curriculumProgramDocument && programRequestDetail.curriculumProgramDocument.id === -1){
      const curriculumDocumentRequest = {
        document: programRequestDetail.curriculumProgramDocument.file,
        documentTypeId: DocumentType.CurriculumProgram
      } as DocumentUploadRequest;

      var idDoc = await uploadDocument(curriculumDocumentRequest)      
      const curriculumProgramDocument = programRequestDetail.curriculumProgramDocument;
      curriculumProgramDocument.id = idDoc;
      setProgramRequestDetail((prev) => ({
        ...prev,
        curriculumProgramDocument: curriculumProgramDocument,
        curriculumProgramDocumentId: idDoc
      }));      
    }      
  };

  const uploadAdditionalDocumentationDocuments = async() => {
    const promises = [] as Promise<void>[];

    if(programRequestDetail.additionalDocumentation && programRequestDetail.additionalDocumentation.length > 0){
      programRequestDetail.additionalDocumentation.map((document, documentIndex) => {
        if(document && document.additionalDocumentationDocument.id === -1){
          const additionalDocumentationDocumentRequest = {
            document: document.additionalDocumentationDocument.file,
            documentTypeId: DocumentType.AdditionalDocumentation
          } as DocumentUploadRequest;
          const additionalDocumentationDocumentPromise = uploadDocument(additionalDocumentationDocumentRequest).then((idDoc) => {
            var additionalDocumentationList = programRequestDetail.additionalDocumentation.slice();
            if(additionalDocumentationList && additionalDocumentationList.length > 0){
              additionalDocumentationList[documentIndex]!.additionalDocumentationDocument.id = idDoc;
              setProgramRequestDetail((prev) => ({
                ...prev,
                additionalDocumentation: additionalDocumentationList
              }));
            }
          });
          promises.push(additionalDocumentationDocumentPromise);
        }
      });
      await Promise.all(promises);
    }
  };

  const doSave = async () => {
    setSaveConfirmModalState(ConfirmModalState.Closed);
    // Teacher Language documents are saved immediately.
    // New Teacher documents are not!
    if (isConsentForeignLanguageType) {
      const arr = await doSaveTeacherDocuments();
      saveForeignLanguage(programRequest.id, arr).then(() => {
        setSaveConfirmModalState(ConfirmModalState.Message);
      });
    } else if (isConsentForHarmonization) {
      //upload document
      await uploadCurriculumProgramDocument();
      await uploadAdditionalDocumentationDocuments();

      createHarmonization(programRequest.id, programRequestDetail).then(() => {
        setSaveConfirmModalState(ConfirmModalState.Message);
      });
    }
    else if(subsequentTeacherAddition){
      const arr = await doSaveTeacherDocuments();
      saveTeachers(programRequest.id, arr).then(() => {
        setSaveConfirmModalState(ConfirmModalState.Message);
      });
    }
  };

  const getRoleName = (roleId: number) => {
    switch (roleId) {
      case RoleEnum.InstitutionAdmin:
        return t("common.institutionAdmin");
      case RoleEnum.CASAdmin:
        return t("common.MZOMAdmin");
      case RoleEnum.ASOOAdmin:
        return t("common.ASOO");
      case RoleEnum.Helpdesk:
        return t("common.Helpdesk");
      case RoleEnum.InstitutionDirector:
        return t("common.institutionDirector");
      case RoleEnum.ASOOManager:
        return t("common.ASOOManager");
      case RoleEnum.CASManager:
        return t("common.MZOManager");
      case RoleEnum.ASOOOffice:
        return t("common.ASOOOffice");
      case RoleEnum.CASOffice:
        return t("common.MZOOffice");
      default:
        return "";
    }
  }

  let lastModifiedDate = hrDate(institution?.lastModified!);
  let lastModifiedHeader = t("institution.lastModifiedHeader") + ": " + lastModifiedDate;
  lastModifiedHeader += " (" + institution?.user! + ", " + getRoleName(institution.userRoleId) + ")";
  // lastModifiedHeader += " (" + institution?.user! + ", " + t("common.institutionAdministrator") + ")";

  const handleCurriculumProgramRemoved = (event: React.ChangeEvent<HTMLInputElement>) => {
    if(programRequestDetail.curriculumProgramDocument === undefined || programRequestDetail.curriculumProgramDocument === null){
      return;
    }

    setProgramRequestDetail((prev) => ({
      ...prev,
      curriculumProgramDocument: undefined            
    }));
  };

  const handleCurriculumProgramAdded = (file: File, event: React.ChangeEvent<HTMLInputElement>) => {
    const curriculumDocument: DocumentData = {
      id: -1,
      fileName: file.name,
      file: file
    };
    setProgramRequestDetail((prev) => ({
      ...prev,
      curriculumProgramDocument: curriculumDocument
    }));
  };

  const getArrowButtonLabel = () => {
    if (location.state && location.state.previousPage) {
      switch (location.state.previousPage) {
        case PreviousPage.DashboardPage: {
          return t("common.returnToDashboard");
        }
        case PreviousPage.ProgramRequestListPage: {
          return t("common.returnToRequestList");
        }
        //ovaj slučaj je bolje ne implementirati!
        // case PreviousPage.ProgramRequestDetailPage: {
        //   return t("common.returnToProgramRequestDetail");        
        // }
        case PreviousPage.NISOO2ProgramRequestListPage: {
          return t("common.returnToNISOO2RequestList");
        }
        default: {
          return t("common.returnToRequestList");
        }
      }
    }
    return t("common.returnToRequestList");
  };

  const handleAdditionalDocumentationRemove = (index: number) => {
    const newAdditionalDocumentation: AdditionalDocumentation[] = [...programRequestDetail.additionalDocumentation];

    if(index !== -1){
      newAdditionalDocumentation.splice(index, 1);
      setProgramRequestDetail((prev) => ({
        ...prev,
        additionalDocumentation: newAdditionalDocumentation
      }));
    }
  };

  const handleAdditionalDocumentationDownload = (doc: DocumentData) => {
    if(doc.id === undefined){
      return;
    }
    if(doc.id === -1){
      saveAs(doc.file!, doc.fileName);
    }
    else {
      downloadDocument(DocumentType.AdditionalDocumentation, doc.id);
    }
  };

  const handleAdditionalDocumentationConfirm = (documents: DocumentData[]) => {
    if(documents && documents.length > 0){
      const additionalDocumentationDocuments = programRequestDetail.additionalDocumentation ? programRequestDetail.additionalDocumentation.slice() : [];
      const additionalDocumentation: AdditionalDocumentation[] = documents.map(doc => ({
        additionalDocumentationTypeId: AdditionalDocumentationType.AdditionalDocumentationASOO,
        additionalDocumentationDocument: doc
      }));
      additionalDocumentationDocuments.push(...additionalDocumentation);

      const newProgramRequestDetail: ProgramRequestDetail = {
        ...programRequestDetail,
        additionalDocumentation: additionalDocumentationDocuments
      };

      setProgramRequestDetail(newProgramRequestDetail);
    }

    setOpenUploadAdditionalDocumentationModal(false);
  };

  return (
    <>
      <Row>
        <Col md={6}>
          <ArrowButton
            backwards
            ariaLabel={getArrowButtonLabel()}
            onClick={onBackToRequestList}
          />
          <span className={styles.backButtonCaption}>
            {getArrowButtonLabel()}
          </span>

        </Col>
        {showPdfExport &&
          <Col md={6}>
            <div className={styles.infoTooltipPanel}>
              <Tooltip
                overlay={<div className={styles.infoTooltip}>{t("request.requestNotNeedSend")}</div>}
                placement="bottom"
                flip
              >
                <IconWrapper color="primary">
                  <InfoIcon />
                </IconWrapper>
              </Tooltip>
              <Button onClick={onDownloadPdf} className={styles.actionButton}>
                {t("common.downloadPdf")}
              </Button>
            </div>
          </Col>
        }
      </Row>
      {userSession && (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector) &&
        programRequest.requestStatusId === ProgramRequestStatus.Paused &&
        <Row>
          <Col md={12}>
            <div className={styles.editButtonPanel}>
              <Button onClick={onSubmitPausedRequest} className={styles.actionButton}>
                {t("request.submitPausedRequest")}
              </Button>
            </div>
          </Col>
        </Row>
      }
      {userSession && (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector)
        && (programRequest.requestStatusId === ProgramRequestStatus.Opened
          || programRequest.requestStatusId === ProgramRequestStatus.Evaluated
          || programRequest.requestStatusId === ProgramRequestStatus.SentMZO
          || programRequest.requestStatusId === ProgramRequestStatus.UnlockedASOO
          || programRequest.requestStatusId === ProgramRequestStatus.UnlockedMZO) &&
        programRequest.isEditable &&
        <Row>
          <Col md={12}>
            <div className={styles.editButtonPanel}>
              <Button
                onClick={onEditRequest}
                className={styles.actionButton}
                disabled={!institution || !institution.andragogicLeaders || institution.andragogicLeaders.length === 0}>
                {t("request.editRequest")}
              </Button>
            </div>
          </Col>
        </Row>
      }
      {userSession && (userSession.roleId === RoleEnum.ASOOOffice || userSession.roleId === RoleEnum.CASOffice)
        && (programRequest.programRequestDetail.envelope?.classificationMark || programRequest.programRequestDetail.envelope?.registryNumber || programRequest.programRequestDetail.envelope?.registrationDate) &&
        <Row>
          <Col md={12}>
            <div className={styles.editButtonPanel}>
              <Tooltip
                overlay={<div className={styles.infoTooltip}>{userSession.roleId === RoleEnum.ASOOOffice ? t("request.ASOOOficeTooltip") : t("request.MZOOfficeTooltip")}</div>}
                placement="bottom"
                flip
              >
                <IconWrapper color="primary">
                  <InfoIcon />
                </IconWrapper>
              </Tooltip>
              <Button
                className={styles.actionButton}
                onClick={onOfficeEditRequest}
              >
                {t("request.editRequest")}
              </Button>
            </div>
          </Col>
        </Row>
      }

      {userSession && (userSession.roleId === RoleEnum.ASOOManager || userSession.roleId === RoleEnum.Helpdesk) && programRequest.isEditable &&
        programRequest.programRequestDetail.envelope?.receivedById &&
        (programRequest.requestStatusId === ProgramRequestStatus.SubmittedASOO || programRequest.requestStatusId === ProgramRequestStatus.HarmonizationASOO ||
          programRequest.requestStatusId === ProgramRequestStatus.CancelledASOO) &&
        <Row className={styles.title}>
          <Col md={12}>
            <div className={styles.editButtonPanel}>
              <Button
                outline
                className={styles.actionButton}
                onClick={() => onAssignDifferentAdministratorClick()}>
                {t("request.assignDifferentAdministrator")}
              </Button>
            </div>
          </Col>
        </Row>
      }

      {userSession && (userSession.roleId === RoleEnum.ASOOAdmin || userSession.roleId === RoleEnum.ASOOManager) && programRequest.isEditable &&
        programRequest.programRequestDetail.envelope?.receivedById && programRequest.programRequestDetail.envelope?.receivedById === userSession.userId &&
        ((programRequest.requestStatusId === ProgramRequestStatus.SubmittedASOO &&
          <Row className={styles.title}>
            <Col md={12}>
              <div className={styles.editButtonPanel}>
                <Button outline onClick={() => onCreateRequestResolution(ResolutionDocumentType.ExpertOpinion)} className={styles.actionButton}>
                  {t("request.judgeRequest")}
                </Button>
                <Button
                  outline
                  onClick={() => onCreateRequestResolution(ResolutionDocumentType.UnlockRequestASOO)}
                  className={styles.actionButton}>
                  {t("request.unlockRequest")}
                </Button>
              </div>
            </Col>
          </Row>
        )
          ||
          (programRequest.requestStatusId === ProgramRequestStatus.HarmonizationASOO &&
            <Row className={styles.title}>
              <Col md={12}>
                <div className={styles.editButtonPanel}>
                  {programRequestDetail.envelope?.programRequestTypeId === ProgramRequestType.ConsentForHarmonizationASOO &&
                    <Button outline onClick={() => handleConsentCreate(ResolutionDocumentType.HarmonizationDecisionASOO)} className={styles.actionButton}>
                      {t("harmonization.ministryConsentButton")}
                    </Button>
                  }
                </div>
              </Col>
            </Row>
          )
          ||
          (programRequest.requestStatusId === ProgramRequestStatus.CancelledASOO &&
            <Row className={styles.title}>
              <Col md={12}>
                <div className={styles.editButtonPanel}>
                  <Button outline onClick={() => handleConsentCreate(ResolutionDocumentType.ArchiveASOO)} className={styles.actionButton}>
                    {t("revocation.agencyRevocationButton")}
                  </Button>
                </div>
              </Col>
            </Row>
          ))
      }

      {userSession && (userSession.roleId === RoleEnum.CASManager || userSession.roleId === RoleEnum.Helpdesk) && programRequest.isEditable &&
        programRequest.programRequestDetail.envelope?.receivedById &&
        (programRequest.requestStatusId === ProgramRequestStatus.SubmittedMZO || programRequest.requestStatusId === ProgramRequestStatus.SentMZO ||
          programRequest.requestStatusId === ProgramRequestStatus.ConsentMZO || programRequest.requestStatusId === ProgramRequestStatus.CancelledMZO
          || programRequest.requestStatusId === ProgramRequestStatus.PausedMZOM) &&
        // programRequest.requestStatusId === ProgramRequestStatus.ConsentMZO || programRequest.requestStatusId === ProgramRequestStatus.CancelledMZO ||
        // programRequest.requestStatusId === ProgramRequestStatus.HarmonizationMZO) &&
        <Row className={styles.title}>
          <Col md={12}>
            <div className={styles.editButtonPanel}>
              <Button
                outline
                className={styles.actionButton}
                onClick={() => onAssignDifferentAdministratorClick()}>
                {t("request.assignDifferentAdministrator")}
              </Button>
            </div>
          </Col>
        </Row>
      }

      {userSession && (userSession.roleId === RoleEnum.CASAdmin || userSession.roleId === RoleEnum.CASManager || userSession.roleId === RoleEnum.Helpdesk) && programRequest.isEditable &&
        programRequest.programRequestDetail.envelope?.receivedById && programRequest.programRequestDetail.envelope?.receivedById === userSession.userId &&
        ((programRequest.requestStatusId === ProgramRequestStatus.SubmittedMZO &&
          <Row className={styles.title}>
            <Col md={12}>
              <div className={styles.editButtonPanel}>
                <Button
                  outline
                  onClick={() => onCreateRequestResolution(ResolutionDocumentType.ExecutionResolution)}
                  className={styles.actionButton}
                  disabled={programRequest.programRequestResolutions?.find(v => v.documentTypeId === ResolutionDocumentType.CommitteeMembership) !== undefined
                    && programRequest.programRequestResolutions?.find(v => v.documentTypeId === ResolutionDocumentType.InspectionReport) === undefined}>
                  {t("request.executionRequest")}
                </Button>
                {(programRequest.programRequestResolutions?.find(v => v.documentTypeId === ResolutionDocumentType.CommitteeMembership) !== undefined
                  && programRequest.programRequestResolutions?.find(v => v.documentTypeId === ResolutionDocumentType.InspectionReport) === undefined) &&
                  <Button
                    outline
                    onClick={() => onCreateRequestResolution(ResolutionDocumentType.InspectionReport)}
                    className={styles.actionButton}
                    disabled={programRequestCorrection !== null}>
                    {t("request.inspectionReportRequest")}
                  </Button>
                }
                {(programRequest.programRequestResolutions?.find(v => v.documentTypeId === ResolutionDocumentType.CommitteeMembership) === undefined) &&
                  <Button
                    outline
                    onClick={() => onCreateRequestResolution(ResolutionDocumentType.CommitteeMembership)}
                    className={styles.actionButton}
                    disabled={programRequestCorrection !== null}>
                    {t("request.committeeMembershipRequest")}
                  </Button>
                }
                <Button
                  outline
                  onClick={() => onCreateRequestResolution(ResolutionDocumentType.UnlockRequestMZO)}
                  className={styles.actionButton}>
                  {t("request.unlockRequest")}
                </Button>
              </div>
            </Col>
          </Row>
        )
          ||
          (programRequest.requestStatusId === ProgramRequestStatus.SentMZO &&
            <Row className={styles.title}>
              <Col md={12}>
                <div className={styles.editButtonPanel}>
                  <Button outline onClick={() => onCreateRequestResolution(ResolutionDocumentType.ExecutionResolution)} className={styles.actionButton}>
                    {t("request.executionRequest")}
                  </Button>
                </div>
              </Col>
            </Row>
          )
          ||
          (programRequest.requestStatusId === ProgramRequestStatus.ConsentMZO &&
            <Row className={styles.title}>
              <Col md={12}>
                <div className={styles.editButtonPanel}>
                  {programRequestDetail.envelope?.programRequestTypeId === ProgramRequestType.ConsentForExecutionAtTheLocationOfAnotherLegalEntityMZO &&
                    <Button outline onClick={() => handleConsentCreate(ResolutionDocumentType.OtherLegalEntityLocationDecision)} className={styles.actionButton}>
                      {t("otherLegalEntityLocation.ministryConsentButton")}
                    </Button>
                  }
                  {programRequestDetail.envelope?.programRequestTypeId === ProgramRequestType.ConsentForExecutionInAForeignLanguage &&
                    <Button outline onClick={() => handleConsentCreate(ResolutionDocumentType.ForeignLanguageDecision)} className={styles.actionButton}>
                      {t("teacherLanguage.ministryConsentButton")}
                    </Button>
                  }
                  {programRequestDetail.envelope?.programRequestTypeId === ProgramRequestType.RequestForExecutionAtAnotherLocation &&
                    <Button outline onClick={() => handleConsentCreate(ResolutionDocumentType.OtherLocationDecision)} className={styles.actionButton}>
                      {t("otherLocations.ministryConsentButton")}
                    </Button>
                  }
                </div>
              </Col>
            </Row>
          )
          ||
          (programRequest.requestStatusId === ProgramRequestStatus.CancelledMZO &&
            <Row className={styles.title}>
              <Col md={12}>
                <div className={styles.editButtonPanel}>
                  <Button outline onClick={() => handleConsentCreate(ResolutionDocumentType.ArchiveMZO)} className={styles.actionButton}>
                    {t("revocation.ministryRevocationButton")}
                  </Button>
                </div>
              </Col>
            </Row>
          )
          ||
          (programRequest.requestStatusId === ProgramRequestStatus.PausedMZOM &&
            <Row className={styles.title}>
              <Col md={12}>
                <div className={styles.editButtonPanel}>
                  <Button
                    outline
                    onClick={() => onCreateRequestResolution(ResolutionDocumentType.InstitutionBasicDataChangeResolution)}
                    className={styles.actionButton}
                  >
                    {t("request.executionRequest")}
                  </Button>
                </div>
              </Col>
            </Row>
          ))
        // ||
        // (programRequest.requestStatusId === ProgramRequestStatus.HarmonizationMZO &&
        //   <Row className={styles.title}>
        //     <Col md={12}>
        //       <div className={styles.editButtonPanel}>
        //         {programRequestDetail.envelope?.programRequestTypeId === ProgramRequestType.ConsentForHarmonizationMZO &&
        //           <Button outline onClick={() => handleConsentCreate(ResolutionDocumentType.HarmonizationDecisionMZO)} className={styles.actionButton}>
        //             {t("harmonization.ministryConsentButton")}
        //           </Button>
        //         }
        //       </div>
        //     </Col>
        //   </Row>
        // ))
      }

      {userSession && (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector) && programRequest.requestStatusId === ProgramRequestStatus.Approved &&
        programRequest.isEditable &&
        <Row className={styles.title}>
          <Col md={3}>
          </Col>
          <Col md={3} className="text-right">
            <Typography component="span" color="light">
              {t("request.groupProgramRequestTypeTitle")}
            </Typography>
          </Col>
          <Col md={4}>
            <Select
              selectData={codeBookToSelectData(
                EnumUtils.getEnumToCodeBook(ProgramRequestType, "ProgramRequestType")
                  .filter(v => v.id === ProgramRequestType.ConsentForExecutionAtTheLocationOfAnotherLegalEntityMZO
                    || v.id === ProgramRequestType.ConsentForExecutionInAForeignLanguage
                    // || v.id === ProgramRequestType.ConsentForHarmonizationMZO
                    || v.id === ProgramRequestType.ConsentForHarmonizationASOO
                    || v.id === ProgramRequestType.RequestForExecutionAtAnotherLocation)
              )}
              value={programRequestType}
              onChange={(e) => setProgramRequestType(e.target.value)}
              emptyOption={{ text: "", value: undefined }}
              disabled={isConsentForeignLanguageType || isConsentForHarmonization || (programRequest.requestStatusId === ProgramRequestStatus.Approved 
                          && (!programRequest.programRequestDetail.programRequestTeachers || programRequest.programRequestDetail.programRequestTeachers.length === 0))}
            />
          </Col>
          <Col md={2}>
            <Button
              outline
              onClick={handleProgramRequestTypeClick}
              className={styles.editButton}
              disabled={!programRequestType || isConsentForeignLanguageType || isConsentForHarmonization || !institution || !institution.andragogicLeaders || institution.andragogicLeaders.length === 0}
            >
              {t("request.editProgramRequest")}
            </Button>
          </Col>
        </Row>
      }

      {programRequestDetail && programRequestDetail.isCurrent && programRequestDetail.isAutomaticallySubmitted && userSession && (userSession.roleId === RoleEnum.Helpdesk
        || (programRequestDetail.envelope?.receivedById && programRequestDetail.envelope.receivedById === userSession.userId)) &&

        <>
          <br />

          <Row>
            <Col md={12}>
              <InfoPanel
                message={t("request.automaticallySubmittedInfoPanel")}
                color="danger"
                fullWidth
              />
            </Col>
          </Row>
        </>
      }


      {programRequest && !programRequest.isEditable &&
        <>
          <br />

          <Row>
            <Col md={12}>
              <InfoPanel
                message={t("request.historicalRequestDetailsInfoPanel")}
                color="warning"
                fullWidth
              />
            </Col>
          </Row>
        </>
      }

      {userSession && (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector) 
        && programRequest.requestStatusId === ProgramRequestStatus.Approved && (!programRequest.programRequestDetail.programRequestTeachers 
        || programRequest.programRequestDetail.programRequestTeachers.length === 0) && 
        <Row className={styles.title}>
          <Col md={9}>
            <InfoPanel
              message={t("request.teachersInformationMissing")}
              color="warning"
              fullWidth  
              className={styles.infoPanelSpacer}
            />
          </Col>
          <Col md={3}>
            <Button
              outline
              className={styles.editButtonInline}
              onClick={() => { setSubsequentTeacherAddition(true)}}
            >
              {t("request.addTeachersData")}
            </Button>
          </Col>
        </Row>
      }


      <ProgramRequestHeader
        programRequestId={programRequest.id}
        programRequestDate={programRequest.programDate}

        programRequestStatusString={programRequest.requestStatus}
        programRequestStatusId={programRequest.requestStatusId}
      />
      {
        institution &&
        <Row>
          <Col md={12} className={styles.panelsCol}>
            <ExpandablePanel clickableHeader className={styles.panel}>
              <ExpandablePanelHeader className={styles.panelHeader}>
                {t("request.institutionDataPanelTitle")}
                <span className={styles.panelsSubHeader}>{lastModifiedHeader}</span>
              </ExpandablePanelHeader>
              <ExpandablePanelBody>
                <InstitutionPanel institution={institution} />
              </ExpandablePanelBody>
            </ExpandablePanel>
          </Col>
        </Row>
      }
      {
        programRequestDetail.envelope &&
        <Row>
          <Col md={12} className={styles.panelsCol}>
            <ExpandablePanel clickableHeader className={styles.panel}>
              <ExpandablePanelHeader className={styles.panelHeader}>
                {t("request.programRequestDataPanelTitle")}
              </ExpandablePanelHeader>
              <ExpandablePanelBody>
                <ProgramRequestEnvelopePanel
                  name={`${nameof<typeof programRequestDetail>("envelope")}`}
                  envelope={programRequestDetail.envelope!}
                  onEditModeChanged={onProgramRequestEnvelopePanelEditModeChanged}
                  isEditMode={isEnvelopeEditMode}
                  onChange={handleChange(setProgramRequestDetail)}
                  isEditable={programRequest.isEditable}
                />
              </ExpandablePanelBody>
            </ExpandablePanel>
          </Col>
        </Row>
      }
      <Row>
        <Col md={12} className={styles.panelsCol}>
          <ExpandablePanel expanded clickableHeader className={styles.panel}>
            <ExpandablePanelHeader className={styles.panelHeader}>
              {t("request.programDataPanelTitle")}
              {userCanEditProgramRequest() && programRequest.isEditable &&
                programRequest.programRequestDetail.envelope?.receivedById && programRequest.programRequestDetail.envelope?.receivedById === userSession?.userId &&
                <Button outline onClick={onEditRequestMzo} className={styles.editButton}>
                  {t("common.edit")}
                </Button>
              }
            </ExpandablePanelHeader>
            <ExpandablePanelBody className={styles.programPanelBody}>
              {ministryAdminMessageUnlock &&
                <Row>
                  <Col md={12}>
                    <InfoPanel
                      message={ministryAdminMessageUnlock}
                      color={"warning"}
                      fullWidth
                    />
                  </Col>
                </Row>
              }
              {ministryAdminMessageReject &&
                <Row>
                  <Col md={12}>
                    <InfoPanel
                      message={ministryAdminMessageReject}
                      color={"danger"}
                      fullWidth
                    />
                  </Col>
                </Row>
              }
              {institutionAdminMessageEdit &&
                <Row>
                  <Col md={12}>
                    <InfoPanel
                      title={t("request.editNoteLabel")}
                      message={institutionAdminMessageEdit}
                      color={"info"}
                      fullWidth
                    />
                  </Col>
                </Row>
              }
              <ProgramRequestDetailPanel
                name="."
                programRequest={programRequest}
                programRequestDetail={programRequestDetail}
                programRequestOriginal={programRequestCorrection}
                onChange={handleChange(setProgramRequestDetail)}
                onProgramRequestDetailChange={handleProgramRequestDetailChange}
                getErrorForPath={getErrorForPath}
                readonly={!isConsentForHarmonization}
                errors={errors}
              />             

             

              {programRequest.programRequestDetail.programRequestTeachers && programRequest.programRequestDetail.programRequestTeachers.length > 0 && ((!isConsentForeignLanguageType &&
                <ProgramRequestTeacherPanel
                  requestTeachers={programRequest.programRequestDetail.programRequestTeachers}
                  requestTeachersCorrections={programRequestCorrection?.programRequestTeachers}
                />) ||
                <TeacherInfo
                  name={`${nameof<typeof programRequestDetail>("programRequestTeachers")}`}
                  teachers={programRequestDetail.programRequestTeachers}
                  showLanguages={true}
                  allowAdd={true}
                  onChange={handleChange(setProgramRequestDetail)}
                  getErrorForPath={getErrorForPath}
                  doValidations={doValidations}
                />)
              }

              {programRequest.programRequestDetail.programRequestTeachers.length === 0 && subsequentTeacherAddition &&
                <TeacherInfo
                  name={`${nameof<typeof programRequestDetail>("programRequestTeachers")}`}                  
                  teachers={programRequestDetail.programRequestTeachers}
                  showLanguages={false}
                  allowAdd={true}
                  onChange={handleChange(setProgramRequestDetail)}
                  getErrorForPath={getErrorForPath}
                  doValidations={doValidations}
                />
              }

              

              {((programRequest.isEditable && isConsentForHarmonization) 
                || (programRequest.programRequestDetail.additionalDocumentation
                && programRequest.programRequestDetail.additionalDocumentation.filter(doc => doc.additionalDocumentationTypeId === AdditionalDocumentationType.AdditionalDocumentationASOO).length > 0)) &&
                <>
                  <Row>
                    <Col md={12} className={styles.rowTitleSpacing}>
                      <Typography variant="smallHeading" component="h3">
                        {t("request.additionalDocumentationASOO")}
                      </Typography>
                    </Col>
                  </Row>
                  {programRequest.isEditable && isConsentForHarmonization && programRequestDetail.additionalDocumentation 
                    && programRequestDetail.additionalDocumentation.filter(doc => doc.additionalDocumentationTypeId === AdditionalDocumentationType.AdditionalDocumentationASOO).length > 0 &&                    
                    <Row>
                      <Col md={12}>
                        {programRequestDetail.additionalDocumentation.filter(doc => doc.additionalDocumentationTypeId === AdditionalDocumentationType.AdditionalDocumentationASOO).map((doc, index) => (
                          <DocumentListItem
                            key={index}
                            removable={true}
                            document={doc.additionalDocumentationDocument}
                            onRemoveClick={() => handleAdditionalDocumentationRemove(index)}
                            onDocumentClick={(doc) => handleAdditionalDocumentationDownload(doc)}
                          />                          
                        ))}  
                      </Col>                                              
                    </Row>                    
                  }
                  {!(programRequest.isEditable && isConsentForHarmonization) && programRequest.programRequestDetail.additionalDocumentation 
                    && programRequest.programRequestDetail.additionalDocumentation.filter(doc => doc.additionalDocumentationTypeId === AdditionalDocumentationType.AdditionalDocumentationASOO).length > 0 &&
                      <Row className={styles.dataRow}>
                        <Col md={12}>
                          <DocumentList
                            documents={programRequest.programRequestDetail.additionalDocumentation.filter(doc => doc.additionalDocumentationTypeId === AdditionalDocumentationType.AdditionalDocumentationASOO).map(doc => doc.additionalDocumentationDocument)}
                            removable={false}
                            onDocumentClick={(doc) => handleAdditionalDocumentationDownload(doc)}
                          />
                        </Col>
                      </Row>
                  }
                  {programRequest.isEditable && isConsentForHarmonization &&
                    <Row>
                      <Col md={4}>
                        <Button
                          outline
                          color={"primary"}
                          className={styles.uploadButton}
                          icon={<UploadIcon />}
                          onClick={() => setOpenUploadAdditionalDocumentationModal(true)}
                        >
                          {t("common.addDocument")}
                          {<span className={styles.toolTipText}>{t("request.additionalDocumentationToolTipASOO")}</span>}
                        </Button>
                      </Col>
                    </Row>                                        
                  }
                </>
              }

              {programRequest.programRequestDetail.additionalDocumentation.filter(doc => doc.additionalDocumentationTypeId === AdditionalDocumentationType.AdditionalDocumentationMZOM).length > 0 && 
                <>
                  <Row>
                    <Col md={12} className={styles.rowTitleSpacing}>
                      <Typography variant="smallHeading" component="h3">
                        {t("request.additionalDocumentationMZOM")}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className={styles.dataRow}>
                    <Col md={12}>
                      <DocumentList
                        documents={programRequest.programRequestDetail.additionalDocumentation.filter(doc => doc.additionalDocumentationTypeId === AdditionalDocumentationType.AdditionalDocumentationMZOM).map(doc => doc.additionalDocumentationDocument)}
                        removable={false}
                        onDocumentClick={(document) => downloadDocument(DocumentType.AdditionalDocumentation, document.id!)}
                      />
                    </Col>
                  </Row>
                </>                
              }
              

              <ProgramRequestModulePanel
                name={`${nameof<typeof programRequestDetail>("modules")}`}
                modules={programRequestDetail.modules}
                programTypeId={programRequest.programTypeId}
                qualificationTypeId={programRequestDetail.qualificationTypeId}
                correctionModules={programRequestCorrection?.modules}
                readonly={!isConsentForHarmonization}
                getErrorForPath={getErrorForPath}
                onChange={handleChange(setProgramRequestDetail)}
              />

              <Row>
                <Col md={12} className={styles.rowTitleSpacing}>
                  <Typography variant="smallHeading" component="h3">
                    {t("request.curriculum")}                        
                  </Typography>
                </Col>
              </Row>
              <Row className={styles.dataRow}>
                <Col md={(programRequest.isEditable && isConsentForHarmonization) ? 12 : 3} className={(programRequest.isEditable && isConsentForHarmonization) ? "" : styles.hideUploadButton}>
                  <UploadButton
                    name={nameof<typeof programRequestDetail>("curriculumProgramDocument")}
                    value={programRequestCorrection?.curriculumProgramDocument ?? programRequestDetail.curriculumProgramDocument}
                    disabled={!(programRequest.isEditable && isConsentForHarmonization)}
                    documentType={DocumentType.CurriculumProgram}
                    onFileAdded={(programRequest.isEditable && isConsentForHarmonization) ? handleCurriculumProgramAdded : undefined}
                    onFileRemoved={(programRequest.isEditable && isConsentForHarmonization) ? handleCurriculumProgramRemoved : undefined}
                    toolTip={(programRequest.isEditable && isConsentForHarmonization) ? t("document.wordAndPdfTooltip") : undefined}
                    fileFilter={(programRequest.isEditable && isConsentForHarmonization) ? t("document.wordAndPdfFilter") : undefined}
                    errorText={(programRequest.isEditable && isConsentForHarmonization) ? errors?.curriculumProgramDocument : undefined}
                  />                                  
                </Col>

              </Row>

              {(programRequestDetail.locationHeadquarter) && (
                <>
                  <Row>
                    <Col md={12} className={styles.rowTitleSpacing}>
                      <Typography variant="smallHeading" component="h3">
                        {t("request.headquarterExecutionPlaceTitle")}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className={styles.dataRow}>
                    <Col md={3}>
                      <StaticField
                        label={t("common.address")}
                        value={institution?.address!}
                      />
                    </Col>
                    <Col md={3}>
                      <StaticField
                        label={t("common.town")}
                        value={institution?.town.name!}
                      />
                    </Col>
                    <Col md={3}>
                      <StaticField
                        label={t("common.municipality")}
                        value={institution?.town.municipalityName!}
                      />
                    </Col>
                    <Col md={3}>
                      <StaticField
                        label={t("common.county")}
                        value={institution?.town.countyName!}
                      />
                    </Col>
                  </Row>
                </>
              )}
              {(programRequestDetail.outsideHeadquarter && programRequestDetail.outsideHeadquarterIds.length > 0) && (
                <>
                  <Row>
                    <Col md={12} className={styles.rowTitleSpacing}>
                      <Typography variant="smallHeading" component="h3">
                        {t("request.outsideHeadquarterExecutionPlaceTitle")}
                      </Typography>
                    </Col>
                  </Row>

                  {institution.locations.filter(x => programRequestDetail.outsideHeadquarterIds.includes(x.id)).map(lc => (
                    <Row key={lc.id} className={styles.dataRow}>
                      <Col md={3}>
                        <StaticField
                          label={t("common.address")}
                          value={lc.address}
                        />
                      </Col>
                      <Col md={3}>
                        <StaticField
                          label={t("common.town")}
                          value={lc.town.name}
                        />
                      </Col>
                      <Col md={3}>
                        <StaticField
                          label={t("common.municipality")}
                          value={lc.town.municipalityName}
                        />
                      </Col>
                      <Col md={3}>
                        <StaticField
                          label={t("common.county")}
                          value={lc.town.countyName}
                        />
                      </Col>
                    </Row>

                  ))}

                </>
              )}
              {(programRequestDetail.locationOtherLegalEntity && otherLegalEntityLocationFilteredList && otherLegalEntityLocationFilteredList.length > 0) && (
                <>
                  <Row>
                    <Col md={12} className={styles.rowTitleSpacing}>
                      <Typography variant="smallHeading" component="h3">
                        {t(
                          "request.anotherLegalEntityLocationExecutionPlaceTitle"
                        )}
                      </Typography>
                    </Col>
                  </Row>

                  {otherLegalEntityLocationFilteredList &&
                    otherLegalEntityLocationFilteredList.length > 0 &&
                    otherLegalEntityLocationFilteredList.map(
                      (otherLegalEntityLocation, otherLocationIndex) => {
                        return (
                          <OtherLegalEntityPanel otherLegalEntityLocation={otherLegalEntityLocation} />
                        );
                      }
                    )}
                </>
              )}
              {(programRequestDetail.otherLocations && programRequestDetail.otherLocations.length > 0) &&
                <>
                  <Row>
                    <Col md={12} className={styles.rowTitleSpacing}>
                      <Typography variant="smallHeading" component="h3">
                        {t("request.otherLocationTitle")}
                      </Typography>
                    </Col>
                  </Row>
                  {programRequestDetail.otherLocations.map(ol => (
                    <Row className={styles.dataRow}>
                      <Col md={3}>
                        <StaticField
                          label={t("common.address")}
                          value={ol.address}
                        />
                      </Col>
                      <Col md={3}>
                        <StaticField
                          label={t("common.town")}
                          value={ol.townName}
                        />
                      </Col>
                      <Col md={3}>
                        <StaticField
                          label={t("common.municipality")}
                          value={ol.municipalityName}
                        />
                      </Col>
                      <Col md={3}>
                        <StaticField
                          label={t("common.county")}
                          value={ol.countyName}
                        />
                      </Col>
                    </Row>
                  ))}
                </>
              }
              {programRequestDetail.remarkInstitution && programRequestDetail.remarkInstitution.length > 0 &&
                <>
                  <Row>
                    <Col md={12} className={styles.rowTitleSpacing}>
                      <Typography variant="smallHeading" component="h3">
                        {t("request.noteInstitution")}
                      </Typography>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <StaticField
                        label={""}
                        value={programRequestDetail.remarkInstitution}
                        className={styles.remarkArea}
                      />
                    </Col>
                  </Row>
                </>
              }
              {((programRequestDetail.remark && programRequestDetail.remark.length > 0) || (programRequestCorrection?.remark && programRequestCorrection.remark.length > 0)) &&
                <>
                  <Row>
                    <Col md={12} className={styles.rowTitleSpacing}>
                      <Typography variant="smallHeading" component="h3">
                        {/* {t("request.noteMinistry")} */}
                        {t("common.note")}
                      </Typography>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <StaticField
                        label={""}
                        value={programRequestDetail.remark}
                        newValue={programRequestCorrection?.remark}
                        className={styles.changedField}
                      />
                    </Col>
                  </Row>
                </>
              }
            </ExpandablePanelBody>
          </ExpandablePanel>
        </Col>
      </Row>

      {
        programRequest.programRequestResolutions && programRequest.programRequestResolutions.length > 0 &&
        <Row>
          <Col md={12} className={styles.panelsCol}>
            <ExpandablePanel clickableHeader className={styles.panel}>
              <ExpandablePanelHeader className={styles.panelHeader}>
                {t("request.programResolution")}
              </ExpandablePanelHeader>
              <ExpandablePanelBody>
                {programRequest.programRequestResolutions && programRequest.programRequestResolutions.map((per) => {                  
                  if (per.documentTypeId === ResolutionDocumentType.UnlockRequestMZO &&
                    (userSession?.roleId === RoleEnum.ASOOAdmin || userSession?.roleId === RoleEnum.ASOOManager || userSession?.roleId === RoleEnum.ASOOOffice)) {
                    return <></>;
                  }                  
                  return (
                    <>
                      <Row key={per.id}>
                        <Col md={12} className={styles.rowTitleSpacing}>
                          <Typography variant="smallHeading" component="h3">
                            {getResolutionDocumentCaption(per.documentTypeId)}
                          </Typography>
                        </Col>
                      </Row>

                      <Row className={styles.dataRow}>
                        <Col md={3} className={styles.hideUploadButton}>
                          <UploadButton
                            label={getResolutionDocumentCaption(per.documentTypeId, "Document")}
                            name={nameof<typeof programRequest>("programRequestResolutions")}
                            value={per?.resolutionDocument}
                            disabled={true}
                            documentType={DocumentType.ProgramExecutionResolution}
                          />
                        </Col>
                        <Col md={3}>
                          <StaticField
                            label={getResolutionDocumentCaption(per.documentTypeId, "ClassificationMark")}
                            value={per?.classificationMark ?? ""}
                            className={styles.changedField}
                          />
                        </Col>
                        <Col md={3}>
                          <StaticField
                            label={getResolutionDocumentCaption(per.documentTypeId, "RegisterNumber")}
                            value={per?.registryNumber ?? ""}
                            className={styles.changedField}
                          />
                        </Col>
                        <Col md={3}>
                          <StaticField
                            label={getResolutionDocumentCaption(per.documentTypeId, "IssueDate")}
                            value={per?.issueDate ? hrDate(per.issueDate) : ""}
                            className={styles.changedField}
                          />
                        </Col>
                      </Row>
                    </>);
                })}
                {/* {programRequest.programRequestResolutions && programRequest.programRequestResolutions.map((per) => (
                  <>
                    <Row key={per.id}>
                      <Col md={12} className={styles.rowTitleSpacing}>
                        <Typography variant="smallHeading" component="h3">
                          {getResolutionDocumentCaption(per.documentTypeId)}
                        </Typography>
                      </Col>
                    </Row>

                    <Row className={styles.dataRow}>
                      <Col md={3} className={styles.hideUploadButton}>
                        <UploadButton
                          label={getResolutionDocumentCaption(per.documentTypeId, "Document")}
                          name={nameof<typeof programRequest>("programRequestResolutions")}
                          value={per?.resolutionDocument}
                          disabled={true}
                          documentType={DocumentType.ProgramExecutionResolution}
                        />
                      </Col>
                      <Col md={3}>
                        <StaticField
                          label={getResolutionDocumentCaption(per.documentTypeId, "ClassificationMark")}
                          value={per?.classificationMark ?? ""}
                          className={styles.changedField}
                        />
                      </Col>
                      <Col md={3}>
                        <StaticField
                          label={getResolutionDocumentCaption(per.documentTypeId, "RegisterNumber")}
                          value={per?.registryNumber ?? ""}
                          className={styles.changedField}
                        />
                      </Col>
                      <Col md={3}>
                        <StaticField
                          label={getResolutionDocumentCaption(per.documentTypeId, "IssueDate")}
                          value={per?.issueDate ? hrDate(per.issueDate) : ""}
                          className={styles.changedField}
                        />
                      </Col>
                    </Row>
                  </>
                ))} */}

              </ExpandablePanelBody>
            </ExpandablePanel>
          </Col>
        </Row>
      }
      <Row>
        <Col md={12} className={styles.panelsCol}>
          <ExpandablePanel clickableHeader className={styles.panel}>
            <ExpandablePanelHeader className={styles.panelHeader}>
              {t("request.historyofChanges")}
            </ExpandablePanelHeader>
            <ExpandablePanelBody>
              <ProgramRequestHistoryPanel programRequestId={programRequest.id} requestHistory={programRequest.programRequestStatusHistorys} />
            </ExpandablePanelBody>
          </ExpandablePanel>
        </Col>
      </Row>

      {
        userSession && (userSession.roleId === RoleEnum.ASOOAdmin || userSession.roleId === RoleEnum.ASOOManager) && programRequest.requestStatusId === ProgramRequestStatus.SubmittedASOO && programRequest.isEditable &&
        <Row>
          <Col md={12} className={styles.panelsCol}>
            {programRequestCorrection && programRequest.programRequestDetail.envelope?.receivedById
              && programRequest.programRequestDetail.envelope?.receivedById === userSession.userId &&
              <Button
                outline
                onClick={() => undoProgramRequestChange()} className={styles.actionButton}>
                {t("request.cancelChangesRequest")}
              </Button>
            }
          </Col>
        </Row>
      }
      {
        userSession && (userSession.roleId === RoleEnum.ASOOAdmin || userSession.roleId === RoleEnum.ASOOManager)
        && (programRequest.requestStatusId === ProgramRequestStatus.Evaluated
          || programRequest.requestStatusId === ProgramRequestStatus.RejectedASOO) && programRequest.isEditable &&
        programRequest.programRequestDetail.envelope?.receivedById && programRequest.programRequestDetail.envelope?.receivedById === userSession.userId &&
        <Row>
          <Col md={12} className={styles.panelsCol}>
            <Button
              outline
              color="danger"
              onClick={() => { setIsCorrectionResolution(() => true); onCreateRequestResolution(ResolutionDocumentType.ExpertOpinionCorrection, true); }} className={styles.actionButton}>
              {t("request.correctExpertOpinion")}
            </Button>
          </Col>
        </Row>
      }
      {
        userSession && (userSession.roleId === RoleEnum.CASAdmin || userSession.roleId === RoleEnum.CASManager || userSession.roleId === RoleEnum.Helpdesk) && programRequest.requestStatusId === ProgramRequestStatus.SubmittedMZO &&
        programRequest.isEditable &&
        <Row>
          <Col md={12} className={styles.panelsCol}>
            {programRequestCorrection && programRequest.programRequestDetail.envelope?.receivedById &&
              programRequest.programRequestDetail.envelope?.receivedById === userSession.userId &&
              <Button
                outline
                onClick={() => undoProgramRequestChange()} className={styles.actionButton}>
                {t("request.cancelChangesRequest")}
              </Button>
            }
          </Col>
        </Row>
      }
      {
        userSession
        && (userSession.roleId === RoleEnum.CASAdmin || userSession.roleId === RoleEnum.CASManager || userSession.roleId === RoleEnum.Helpdesk)
        && (programRequest.requestStatusId === ProgramRequestStatus.Rejected
          || programRequest.requestStatusId === ProgramRequestStatus.Approved) && programRequest.isEditable &&
        programRequest.programRequestDetail.envelope?.receivedById && programRequest.programRequestDetail.envelope?.receivedById === userSession.userId &&
        <Row>
          <Col md={12} className={styles.panelsCol}>
            <Button
              outline
              color="danger"
              onClick={() => { setIsCorrectionResolution(() => true); onCreateRequestResolution(ResolutionDocumentType.ExecutionResolutionCorrection, true); }} className={styles.actionButton}>
              {t("request.correctExecutionResolution")}
            </Button>
          </Col>
        </Row>
      }
      {
        userSession && (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector)
        && programRequest.requestStatusId === ProgramRequestStatus.Approved
        && (isConsentForeignLanguageType
          || isConsentForHarmonization || subsequentTeacherAddition) && programRequest.isEditable &&
        <Row style={{ marginLeft: "-15px", marginRight: "-15px" }} className={"pt-2"}>
          <Col md={2}>
            <Button
              outline
              onClick={onBackToRequestList}
            >
              {t("common.cancel")}
            </Button>
          </Col>
          <Col md={7}></Col>
          <Col md={3} className={styles.addDataButtonCol}>
            <Button
              onClick={handleSaveClicked}
              className={styles.saveButton}
              disabled={!institution || !institution.andragogicLeaders || institution.andragogicLeaders.length === 0}
            >
              {subsequentTeacherAddition ? t("common.save") : t("request.submitRequest") }
            </Button>
          </Col>
        </Row>
      }
      {
        userSession
        && (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector)
        && (programRequest.requestStatusId === ProgramRequestStatus.SubmittedASOO
          || programRequest.requestStatusId === ProgramRequestStatus.SubmittedMZO
          || programRequest.requestStatusId === ProgramRequestStatus.UnlockedASOO
          || programRequest.requestStatusId === ProgramRequestStatus.UnlockedMZO) && programRequest.isEditable &&
        <Row style={{ marginLeft: "-15px", marginRight: "-15px" }} className={"pt-2"}>
          <Col md={10}></Col>
          <Col md={2} className={styles.addDataButtonCol}>
            <Button
              onClick={() => setOpenStatusRevokeModal(true)}
              className={styles.saveButton}
              disabled={!institution || !institution.andragogicLeaders || institution.andragogicLeaders.length === 0}
            >
              {t("common.revoke")}
            </Button>
          </Col>
        </Row>
      }
      <ModalResolution
        type="confirm"
        open={openResolutionModal}
        executionDocumentData={resolutionDocument}
        cancelText={t("common.cancel")}
        captions={resolutionModalCaptions}
        confirmText={getResolutionModalElementCaption("confirmText")}
        // rejectText = {isCorrectionResolution ? undefined : getResolutionModalElementCaption("rejectText")}        
        rejectText={getResolutionModalElementCaption("rejectText")}
        onClose={handleCancelResolutionModal}
        onConfirm={(approved, resolution) => handleConfirmedResolutionModal(approved, resolution)}
        showComment={showModalComment}
        forceComment={resolutionDocument.documentTypeId === ResolutionDocumentType.UnlockRequestASOO || resolutionDocument.documentTypeId === ResolutionDocumentType.UnlockRequestMZO}
        documentToolTip={(resolutionDocument.documentTypeId === ResolutionDocumentType.ExpertOpinion || resolutionDocument.documentTypeId === ResolutionDocumentType.ExpertOpinionCorrection) ? t("document.pdfTooltip") : t("document.imagesAndPdfTooltip")}
        documentFilter={(resolutionDocument.documentTypeId === ResolutionDocumentType.ExpertOpinion || resolutionDocument.documentTypeId === ResolutionDocumentType.ExpertOpinionCorrection) ? t("document.pdfFilter") : t("document.imagesAndPdfFilter")}
        resolutionDoc={resolution}
        showProcessingDeadline={resolutionDocument.documentTypeId === ResolutionDocumentType.UnlockRequestASOO || resolutionDocument.documentTypeId === ResolutionDocumentType.UnlockRequestMZO}
      >
        <div className={styles.statusModalPanel}>
          <Typography component="h1" variant="largeBold" className={styles.stytusModelCaption}>
            {getResolutionModalElementCaption("caption")}
          </Typography>
          {(resolutionDocument.documentTypeId === ResolutionDocumentType.ExpertOpinionCorrection || resolutionDocument.documentTypeId === ResolutionDocumentType.ExecutionResolutionCorrection) &&
            <br />
            ||
            <div className={styles.stytusModelTitle}>
              {getResolutionModalElementCaption("title")}</div>
          }
        </div>

      </ModalResolution>

      <ConfirmModal
        confirmState={saveConfirmModalState}
        title={saveConfirmModalTitle}
        confirmDescription={saveConfirmModalDescription}
        confirmMessage={saveConfirmModalMessage}
        successMessage={saveConfirmModalSuccessMessage}
        onClickConfirm={doSave}
        onClickClose={() => { setSaveConfirmModalState(ConfirmModalState.Closed); onBackToRequestList(); }}
        onClickCancel={() => setSaveConfirmModalState(ConfirmModalState.Closed)}
        confirmButton={saveConfirmModalConfirmButton}
        cancelButton={saveConfirmModalCancelButton}
      />

      <ModalStatus
        type="confirm"
        open={openStatusUnlockModal}
        cancelText={t("common.cancel")}
        confirmText={t("request.unlockRequestModalConfirm")}
        onClose={handleCancelUnlockStatusModal}
        onConfirm={(description, userSelection) => handleConfirmedStatusModal(unloackStatus, description, userSelection)}
        showComment={true}
      >
        <div className={styles.statusModalPanel}>
          <Typography component="h1" variant="largeBold" className={styles.stytusModelCaption}>
            {t("request.unlockRequestModalCaption")}
          </Typography>
          <div className={styles.stytusModelTitle}>{t("request.unlockRequestModalTitle")}</div>
          <div className={styles.stytusModelNote} >{t("request.unlockRequestModalNote")}</div>
        </div>
      </ModalStatus>

      <ModalStatus
        type="confirm"
        open={openStatusSubmitMZOModal}
        cancelText={t("common.cancel")}
        confirmText={t("request.changeStatusToMZOSubmitConfirm")}
        onClose={handleCancelSubmitMZOStatusModal}
        onConfirm={(description, userSelection) => handleConfirmedStatusModal(ProgramRequestStatus.SubmittedMZO, description, userSelection)}
        showComment={false}
      >
        <div className={styles.statusModalPanel}>
          <Typography component="h1" variant="largeBold" className={styles.stytusModelCaption}>
            {t("request.changeStatusToMZOSubmitCaption")}
          </Typography>
          <div className={styles.stytusModelTitle}>{t("request.changeStatusToMZOSubmitTitle")}</div>
        </div>
      </ModalStatus>

      <ModalStatus
        type="confirm"
        open={openStatusEditApprovedModal}
        cancelText={t("common.cancel")}
        confirmText={t("request.cancelApproveRequestModalConfirm")}
        onClose={handleCancelEditApprovedStatusModal}
        onConfirm={(description, userSelection) => handleConfirmedStatusModal(ProgramRequestStatus.Opened, description, userSelection)}
        showComment={true}
      >
        <div className={styles.statusModalPanel}>
          <Typography component="h1" variant="largeBold" className={styles.stytusModelCaption}>
            {t("request.cancelApproveRequestModalCaption")}
          </Typography>
          <div className={styles.stytusModelTitle}>{t("request.cancelApproveRequestModalTitle")}</div>
        </div>
      </ModalStatus>

      <ModalStatus
        type="confirm"
        open={openStatusRevokeModal}
        cancelText={t("common.cancel")}
        confirmText={t("request.revokeApproveRequestModalConfirm")}
        onClose={() => setOpenStatusRevokeModal(false)}
        onConfirm={(description, userSelection) => handleConfirmedStatusModal(ProgramRequestStatus.CancelledASOO, description, userSelection)}
        showComment={true}
      >
        <div className={styles.statusModalPanel}>
          <Typography component="h1" variant="largeBold" className={styles.stytusModelCaption}>
            {t("request.revokeApproveRequestModalCaption")}
          </Typography>
          <div className={styles.stytusModelTitle}>{t("request.revokeApproveRequestModalTitle")}</div>
        </div>
      </ModalStatus>

      <Modal
        type="message"
        open={openStatusChangeModal}
        confirmText={t("common.ok")}
        onClose={handleStatusChangeMessageModal}
        onConfirm={handleStatusChangeMessageModal}
      >
        <div className={styles.changeStatusMessage}>
          <div className={styles.statusMessageIconPanel}>
            <IconWrapper color="noted-2">
              <DocumentApprovedIcon aria-label={t("accessibility.documentApprovedIcon")} />
            </IconWrapper>
          </div>
          <Typography variant="largeBold" component="h3">
            {confirmationMessage}
          </Typography>
        </div>
      </Modal>

      <Modal
        type="message"
        open={openLearningSetCodeModal}
        confirmText={t("common.ok")}
        onClose={handleLearningSetCodeModal}
        onConfirm={handleLearningSetCodeModal}
      >
        <div className={styles.changeStatusMessage}>
          <Typography variant="mediumBold" component="h3">
            {learningSetCodeMessage}
          </Typography>
          <Typography variant="medium" component="h4">
            {t("request.learningSetCodeMessage")}
          </Typography>
        </div>
      </Modal>

      <Modal
        type="confirm"
        open={undoProgramRequestChangeModal}
        confirmText={t("request.cancelChangesRequestModalConfirm")}
        cancelText={t("common.cancel")}
        onClose={handleUndoProgramRequestChange}
        onConfirm={handleConfirmedUndoProgramRequestChangeModal}
      >
        <div className={styles.statusModalPanel}>
          <Typography component="h1" variant="largeBold" className={styles.stytusModelCaption}>
            {t("request.cancelChangesRequestModalCaption")}
          </Typography>
          <div className={styles.stytusModelTitle}>{t("request.cancelChangesRequestModalTitle")}</div>
        </div>
      </Modal>

      <OtherLegalEntityLocationModal
        cancelText={t("common.cancel")}
        confirmText={t("groupProgramRequest.otherLegalEntity.submitConsentForExecution")}
        onConfirm={handleConfirmedOtherLegalEntityLocationModalV2}
        open={otherLegalEntityLocationModalOpen}
        value={otherLegalEntityLocation!}
        disableBody={true}
        onClose={handleCancelOtherLegalEntityLocationModal}
      />

      <ConfirmModal
        confirmState={saveConfirmModalLocationState}
        title={t("otherLegalEntityLocation.ministryConsentButton")}
        confirmDescription={t("harmonization.descriptionConsent")}
        confirmMessage={t("otherLegalEntityLocation.message")}
        successMessage={t("otherLegalEntityLocation.successMessage", { id: programRequest.id })}
        onClickConfirm={doSaveOtherLegalEntityLocation}
        onClickClose={() => { setSaveConfirmModalLocationState(ConfirmModalState.Closed); onBackToRequestList(); }}
        onClickCancel={() => setSaveConfirmModalLocationState(ConfirmModalState.Closed)}
        confirmButton={t("harmonization.confirm")}
        cancelButton={t("common.cancel")}
      />

      <ConsentModal
        open={openConsentModal}
        consent={consent!}
        documentFilter={t("document.imagesAndPdfFilter")}
        documentToolTip={t("document.imagesAndPdfTooltip")}
        onClose={handleConsentCancel}
        onConfirm={handleConsentSave}
        onFinish={handleConsentFinish}
        programRequestId={programRequest.id}
      />

      <Modal
        type="confirm"
        open={openCancelModal}
        cancelText={t("common.noProperCase")}
        confirmText={t("common.yesCancel")}
        onClose={handleCancelCancelModal}
        onConfirm={handleConfirmedCancelModal}
      >
        <div>

          <Typography component="h1" variant="largeBold">
            {t("common.areYouSureCancelChanges")}
          </Typography>
          {t("common.areYouSureCancelChangesNote")}
        </div>
      </Modal>

      <Modal
        type="confirm"
        open={openUnlockConfirmationModal}
        cancelText={t("common.noProperCase")}
        confirmText={t("request.unlockRequestConfirmationModalConfirm")}
        onClose={handleCancelConfirmationModal}
        onConfirm={handleConfirmConfirmationModal}
      >
        <div>
          <Typography component="h1" variant="largeBold">
            {t("request.unlockRequestConfirmationModalCaption")}
          </Typography>
          {t("request.unlockRequestConfirmationModalTitle")}
        </div>
      </Modal>

      <Modal
        type="confirm"
        title={t("request.assignAdministratorHeader")}
        variant="big"
        cancelText={t("common.cancel")}
        confirmText={t("request.assignAdministrator")}
        open={isAssignDifferentAdministratorModalOpened}
        onClose={handleToggleCancelAssignDifferentAdministratorModal}
        onConfirm={handleToggleConfirmAssignDifferentAdministratorModal}
      >
        <div>
          <Row>
            <Col md={12}>
              <Typography>{t("request.processingAdministratorModal")}</Typography>
              <br />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Autocomplete
                label={t("request.administrator")}
                name={nameof<typeof assignAdministratorRequest>("administratorId")}
                value={assignAdministratorRequest?.administratorId}
                onChange={handleAdministratorIdChange}
                getOptions={handleAdministratorSearch}
                errorText={assignAdministratorRequest.administratorId === undefined || assignAdministratorRequest.administratorId === null ? t("validations.required") : ""}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Typography>{t("request.programsForProcessing")}</Typography>
              <hr />
            </Col>
          </Row>
          {envelopeData?.programs.map((p) =>
            <Row>
              <Col md={12}>
                <Typography>{p.programName}</Typography>
              </Col>
            </Row>)}
        </div>
      </Modal>

      <Modal
        type="confirm"
        open={isConfirmAssignAdministratorModalOpened}
        cancelText={t("common.noProperCase")}
        confirmText={t("request.assignAdministratorConfirm")}
        onClose={handleCancelConfirmAssignAdministratorModal}
        onConfirm={handleConfirmAssignAdministratorModal}
      >
        <Typography component="h1" variant="largeBold">
          {t("request.assignAdministratorConfirmModal")}
        </Typography>
        <Typography>
          {administratorConfirmationMessage}
        </Typography>
      </Modal>

      <Modal
        type={"confirm"}
        title={t("request.classificationMarkRegistryNumberEditModalHeader")}
        variant="big"
        cancelText={t("common.cancel")}
        confirmText={t("common.save")}
        open={isOfficeEditModalOpened}
        onClose={handleCancelOfficeEditModal}
        onConfirm={handleConfirmOfficeEditModal}
      >
        <div>
          <Row>
            <Col md={12}>
              <Typography>{t("request.classificationMarkRegistryNumberEditTooltip")}</Typography>
              <br />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <TextField
                label={t("common.classificationMark")}
                name={nameof<typeof envelopeClassificationRequest>("classificationMark")}
                value={envelopeClassificationRequest.classificationMark}
                onChange={handleEnvelopeClassificationMarkChange}
                errorText={!envelopeClassificationRequest.classificationMark ? t("validations.required") : ""}

              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <TextField
                label={t("request.resolutionRegisterNumber")}
                name={nameof<typeof envelopeClassificationRequest>("registryNumber")}
                value={envelopeClassificationRequest.registryNumber}
                onChange={handleEnvelopeRegistryNumberChange}
                errorText={!envelopeClassificationRequest.registryNumber ? t("validations.required") : ""}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <DatePicker
                label={t("request.committeeMembershipIssueDate")}
                name={nameof<typeof envelopeClassificationRequest>("registrationDate")}
                value={envelopeClassificationRequest.registrationDate}
                onChange={handleEnvelopeRegistrationDateChange}
                isClearable={true}
                minYear={new Date().getFullYear() - 25}
                maxYear={new Date().getFullYear() + 25}
                showTimePicker={false}
                errorText={!envelopeClassificationRequest.registrationDate ? t("validations.required") : ""}
              />
            </Col>
          </Row>
        </div>
      </Modal>

      <Modal
        type="confirm"
        open={isOfficeEditConfirmModalOpened}
        cancelText={t("common.close")}
        confirmText={t("common.save")}
        onClose={handleCancelOfficeEditConfirmModal}
        onConfirm={handleConfirmOfficeEditConfirmModal}
      >
        <div>
          <Typography component="h1" variant="largeBold">
            {t("common.areYouSureSaveChanges")}
          </Typography>
        </div>

      </Modal>

      <Modal
        type="message"
        open={isOfficeEditSuccessModalOpened}
        confirmText={t("common.close")}
        onClose={handleCloseOfficeEditSuccessModal}
        onConfirm={handleCloseOfficeEditSuccessModal}
      >
        <div className={styles.modalMessageContentAlignCenter}>
          <Typography component="h1" variant="largeBold">
            {t("common.saveSucceed")}
          </Typography>

        </div>

      </Modal>

      <Modal
        id="locationModal"
        type="confirm"
        title={t("ProgramRequestType.RequestForExecutionAtAnotherLocation")}
        variant="big"
        open={otherLocationModalOpen}
        confirmText={t("request.submitRequest")}
        cancelText={t("common.cancel")}
        onClose={() => setOtherLocationModalOpen(false)}
        onConfirm={handleConfirmOtherLocationModal}
      >
        <div>
          <Row>
            <Col md={12}>
              <StaticField
                label={t("institution.institutionName")}
                value={institution.name}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Select
                label={t("request.executionAddress")}
                multiple
                name={nameof<typeof otherLocationRequest>("institutionLocationDetailIds")}
                value={otherLocationRequest.institutionLocationDetailIds}
                onChange={handleExecutionAddressChange}
                errorText={otherLocationValidationError}
                selectData={codeBookToSelectData(filteredLocations)}
              />
            </Col>
          </Row>
        </div>
      </Modal>
      <Modal
        type="confirm"
        open={otherLocationConfirmModalOpen}
        cancelText={t("common.cancel")}
        confirmText={t("common.save")}
        onClose={handleCancelOtherLocationConfirmModalOpen}
        onConfirm={handleConfirmOtherLocationConfirmModalOpen}
      >
        <div>
          <Typography component="h1" variant="largeBold">
            {t("request.requestOtherLocationAreYouSureSubmit")}
          </Typography>
        </div>
      </Modal>
      <Modal
        type="message"
        open={otherLocationSuccessModalOpen}
        confirmText={t("common.close")}
        onClose={handleCloseOtherLocationSuccessModal}
        onConfirm={handleCloseOtherLocationSuccessModal}
      >
        <div className={styles.modalMessageContentAlignCenter}>
          <Typography component="h1" variant="largeBold">
            {t("request.requestOtherLocationSuccessfullySubmited")}
          </Typography>
        </div>
      </Modal>
      <Modal
        type="confirm"
        open={otherLocationCancelModalOpen}
        cancelText={t("common.noProperCase")}
        confirmText={t("common.yesCancel")}
        onClose={handleCancelOtherLocationCancelModal}
        onConfirm={handleConfirmedOtherLocationCancelModal}
      >
        <div>

          <Typography component="h1" variant="largeBold">
            {t("common.areYouSureCancelChanges")}
          </Typography>
          {t("common.areYouSureCancelChangesNote")}
        </div>
      </Modal>
      <Modal
        type="confirm"
        open={openResolutionConfirmModal}
        cancelText={t("common.noProperCase")}
        confirmText={t("common.yesProperCase")}
        onClose={handleCancelResolutionConfirmModal}
        onConfirm={handleConfirmResolutionConfirmModal}
      >
        <div>
          <Typography component="h1" variant="largeBold">
            {getResolutionConfirmModalCaption()}
          </Typography>
        </div>
      </Modal>
      <Modal
        type="confirm"
        open={openPausedRequestConfirmModal}
        cancelText={t("common.noProperCase")}
        confirmText={t("common.yesProperCase")}
        onClose={handleCancelPausedRequestConfirmModal}
        onConfirm={handleConfirmPausedRequestConfirmModal}
      >
        <div>
          <Typography component="h1" variant="largeBold">
            {t("request.areYouSureRequestSubmission")}
          </Typography>
          {t("request.areYouSurePausedRequestSubmissionNote")}
        </div>
      </Modal>
      <Modal
        type="message"
        open={openPausedRequestSuccessModal}
        confirmText={t("common.close")}
        onClose={handleConfirmedPausedRequestSuccessModal}
        onConfirm={handleConfirmedPausedRequestSuccessModal}
      >
        <div className={styles.modalMessageContentAlignCenter}>
          <Typography component="h1" variant="largeBold">
            {t("request.requestSuccessfullySubmittedAndSend")}
          </Typography>
        </div>
      </Modal>
      <DocumentsUploadModal
        title={t("request.additionalDocumentationASOO")}
        infoPanelText={t("request.additionalDocumentationPanelASOO")}
        types={t("document.imagesAndPdfAndWordFilter")}
        allDocuments={programRequestDetail.additionalDocumentation.filter(doc => doc.additionalDocumentationTypeId === AdditionalDocumentationType.AdditionalDocumentationASOO).map(doc => doc.additionalDocumentationDocument)}
        onRemoveUploadedDocument={handleAdditionalDocumentationRemove}
        maxSize={10}
        maxFiles={programRequestDetail.additionalDocumentation ? 10 - programRequestDetail.additionalDocumentation.filter(doc => doc.additionalDocumentationTypeId === AdditionalDocumentationType.AdditionalDocumentationASOO).length : 10}
        filesAction={undefined}
        open={openUploadAdditionalDocumentationModal}
        onConfirm={handleAdditionalDocumentationConfirm}
        onClose={() => setOpenUploadAdditionalDocumentationModal(false)}
        hideOldDocuments={false}
        btnCancelText={t("common.cancel")}
        btnOkText={t("common.ok")}
      />      
    </>
  );
}

